import React from "react";
import { IconContext } from "react-icons";
import { FaBars } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { aiMhIsActives } from "../AiMarketingHub";

function BarsIcon({ isActive }) {
    return (
        <IconContext.Provider
            value={{
                style: {
                    fontSize: "24px",
                    color: `${isActive ? "#67A110" : "rgb(70,70,70)"}`,
                },
            }}
        >
            <div>
                <FaBars />
            </div>
        </IconContext.Provider>
    );
}

function HomeIcon({ isActive }) {
    return isActive === "Home" ? (
        <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.5127 7.72159L10.0127 0.905969C9.73618 0.652993 9.37498 0.512695 9.0002 0.512695C8.62542 0.512695 8.26422 0.652993 7.9877 0.905969L0.4877 7.72159C0.334142 7.86208 0.211499 8.03298 0.127571 8.22343C0.0436425 8.41388 0.000266168 8.61972 0.000200032 8.82784V17.4622C-0.00589792 17.8404 0.127612 18.2075 0.3752 18.4935C0.51572 18.6533 0.688823 18.7811 0.88287 18.8684C1.07692 18.9558 1.28741 19.0005 1.5002 18.9997H6.0002C6.19911 18.9997 6.38988 18.9207 6.53053 18.78C6.67118 18.6394 6.7502 18.4486 6.7502 18.2497V13.7497C6.7502 13.5508 6.82922 13.36 6.96987 13.2194C7.11052 13.0787 7.30129 12.9997 7.5002 12.9997H10.5002C10.6991 12.9997 10.8899 13.0787 11.0305 13.2194C11.1712 13.36 11.2502 13.5508 11.2502 13.7497V18.2497C11.2502 18.4486 11.3292 18.6394 11.4699 18.78C11.6105 18.9207 11.8013 18.9997 12.0002 18.9997H16.5002C16.749 19.0019 16.9942 18.9406 17.2127 18.8216C17.4504 18.6921 17.649 18.5011 17.7875 18.2685C17.9261 18.036 17.9995 17.7704 18.0002 17.4997V8.82784C18.0001 8.61972 17.9568 8.41388 17.8728 8.22343C17.7889 8.03298 17.6663 7.86208 17.5127 7.72159Z"
                fill="#67A110"
            />
        </svg>
    ) : (
        <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.25 17.5V13C11.25 12.801 11.171 12.6103 11.0303 12.4696C10.8897 12.329 10.6989 12.25 10.5 12.25H7.5C7.30109 12.25 7.11032 12.329 6.96967 12.4696C6.82902 12.6103 6.75 12.801 6.75 13V17.5C6.75 17.6989 6.67098 17.8896 6.53033 18.0303C6.38968 18.1709 6.19891 18.25 6 18.25H1.5C1.30109 18.25 1.11032 18.1709 0.96967 18.0303C0.829018 17.8896 0.75 17.6989 0.75 17.5V8.82808C0.751679 8.72429 0.77411 8.62188 0.815972 8.52688C0.857833 8.43189 0.918279 8.34623 0.99375 8.27496L8.49375 1.45933C8.63201 1.33284 8.81261 1.2627 9 1.2627C9.18739 1.2627 9.36799 1.33284 9.50625 1.45933L17.0062 8.27496C17.0817 8.34623 17.1422 8.43189 17.184 8.52688C17.2259 8.62188 17.2483 8.72429 17.25 8.82808V17.5C17.25 17.6989 17.171 17.8896 17.0303 18.0303C16.8897 18.1709 16.6989 18.25 16.5 18.25H12C11.8011 18.25 11.6103 18.1709 11.4697 18.0303C11.329 17.8896 11.25 17.6989 11.25 17.5Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function OrderIcon({ isActive }) {
    return isActive === "My Orders" ? (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.5759 6.75H4.42586C4.24131 6.75087 4.06339 6.81891 3.92536 6.94141C3.78733 7.06391 3.69864 7.23249 3.67586 7.41562L2.34461 19.4156C2.33277 19.5202 2.34306 19.6261 2.37482 19.7264C2.40658 19.8267 2.45909 19.9192 2.52894 19.9979C2.59879 20.0766 2.68442 20.1397 2.78026 20.1831C2.8761 20.2266 2.98001 20.2494 3.08523 20.25H20.9165C21.0217 20.2494 21.1256 20.2266 21.2215 20.1831C21.3173 20.1397 21.4029 20.0766 21.4728 19.9979C21.5426 19.9192 21.5951 19.8267 21.6269 19.7264C21.6587 19.6261 21.6689 19.5202 21.6571 19.4156L20.3259 7.41562C20.3031 7.23249 20.2144 7.06391 20.0764 6.94141C19.9383 6.81891 19.7604 6.75087 19.5759 6.75Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75"
                fill="#67A110"
            />
            <path
                d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.5759 6.75H4.42586C4.24131 6.75087 4.06339 6.81891 3.92536 6.94141C3.78733 7.06391 3.69864 7.23249 3.67586 7.41562L2.34461 19.4156C2.33277 19.5202 2.34306 19.6261 2.37482 19.7264C2.40658 19.8267 2.45909 19.9192 2.52894 19.9979C2.59879 20.0766 2.68442 20.1397 2.78026 20.1831C2.8761 20.2266 2.98001 20.2494 3.08523 20.25H20.9165C21.0217 20.2494 21.1256 20.2266 21.2215 20.1831C21.3173 20.1397 21.4029 20.0766 21.4728 19.9979C21.5426 19.9192 21.5951 19.8267 21.6269 19.7264C21.6587 19.6261 21.6689 19.5202 21.6571 19.4156L20.3259 7.41562C20.3031 7.23249 20.2144 7.06391 20.0764 6.94141C19.9383 6.81891 19.7604 6.75087 19.5759 6.75V6.75Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function ServiceIcon({ isActive }) {
    return isActive === "Services" ? (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.5219 4.65605C19.0138 5.80476 19.1343 7.07856 18.8663 8.29912C18.5983 9.51967 17.9554 10.6259 17.0275 11.4629C16.0996 12.2998 14.9331 12.8257 13.6915 12.9668C12.4499 13.1079 11.1952 12.8572 10.1031 12.2498L4.84375 18.3436C4.42106 18.7662 3.84777 19.0037 3.25 19.0037C2.65222 19.0037 2.07894 18.7662 1.65625 18.3436C1.23356 17.9209 0.996094 17.3476 0.996094 16.7498C0.996094 16.152 1.23356 15.5787 1.65625 15.1561L7.75 9.89668C7.14258 8.80461 6.89188 7.54993 7.03299 6.3083C7.1741 5.06667 7.69996 3.90024 8.53694 2.97233C9.37392 2.04441 10.4801 1.40147 11.7007 1.1335C12.9212 0.865533 14.195 0.985962 15.3437 1.47793L11.4062 5.40605L11.9406 8.05918L14.5937 8.59355L18.5219 4.65605Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.5219 4.65605C19.0138 5.80476 19.1343 7.07856 18.8663 8.29912C18.5983 9.51967 17.9554 10.6259 17.0275 11.4629C16.0996 12.2998 14.9331 12.8257 13.6915 12.9668C12.4499 13.1079 11.1952 12.8572 10.1031 12.2498L4.84375 18.3436C4.42106 18.7662 3.84777 19.0037 3.25 19.0037C2.65222 19.0037 2.07894 18.7662 1.65625 18.3436C1.23356 17.9209 0.996094 17.3476 0.996094 16.7498C0.996094 16.152 1.23356 15.5787 1.65625 15.1561L7.75 9.89668C7.14258 8.80461 6.89188 7.54993 7.03299 6.3083C7.1741 5.06667 7.69996 3.90024 8.53694 2.97233C9.37392 2.04441 10.4801 1.40147 11.7007 1.1335C12.9212 0.865533 14.195 0.985962 15.3437 1.47793L11.4062 5.40605L11.9406 8.05918L14.5937 8.59355L18.5219 4.65605Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function TeamIcon({ isActive }) {
    return isActive === "My Team" ? (
        <svg
            width="28"
            height="16"
            viewBox="0 0 28 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.171 0.486851C12.2755 0.647634 11.4744 1.00991 10.7797 1.56818C10.628 1.69006 10.4902 1.78999 10.4735 1.79021C10.4568 1.79043 10.3017 1.70997 10.1289 1.61136C9.37753 1.18277 8.73861 1.02177 7.80554 1.02591C7.20815 1.02855 7.07413 1.04336 6.70748 1.14708C5.91609 1.37105 5.34634 1.68111 4.82258 2.17289C4.18564 2.77095 3.76934 3.53371 3.62668 4.36401C3.54451 4.84231 3.59284 5.73245 3.72387 6.15276C3.86305 6.59946 4.09732 7.06758 4.35443 7.41294C4.47161 7.57037 4.56753 7.70565 4.56753 7.71362C4.56753 7.72155 4.38207 7.82854 4.15541 7.95138C2.0004 9.11916 0.672721 11.0868 0.508052 13.3569C0.47464 13.8177 0.539634 13.9915 0.80853 14.1602L0.967991 14.2602H3.36083H5.75368L5.72397 14.5356C5.68671 14.8805 5.74654 15.088 5.9312 15.2541L6.07537 15.3838H14H21.9246L22.0688 15.2541C22.2708 15.0724 22.3012 14.9214 22.2567 14.3207C22.1338 12.6604 21.4522 11.1816 20.1991 9.85703C19.6037 9.22755 18.685 8.55552 17.9067 8.18002C17.7454 8.10216 17.6134 8.02413 17.6134 8.00659C17.6134 7.98905 17.6659 7.92834 17.7301 7.87172C17.8946 7.72666 18.2793 7.1932 18.4456 6.87979C19.0551 5.73047 19.0578 4.32749 18.4526 3.11327C18.2377 2.68207 18.2188 2.72367 18.7438 2.47304C19.2292 2.24132 19.5759 2.16959 20.1945 2.17289C20.6429 2.17527 20.7976 2.19519 21.1095 2.29049C21.9071 2.53424 22.5343 3.0358 22.8747 3.70238C23.1275 4.19711 23.2128 4.60644 23.1836 5.18339C23.139 6.06371 22.8499 6.63542 22.1084 7.30904L21.6845 7.69423L21.7059 7.93728C21.734 8.25462 21.8361 8.35362 22.3221 8.53424C23.8251 9.09294 24.9757 10.0588 25.6527 11.3301C25.9553 11.8983 26.2012 12.6501 26.2012 13.0073V13.1146L25.2074 13.1149L25.0632 13.1149C24.0174 13.1152 21.8229 13.1866 21.6964 13.2649C21.5099 13.3803 21.6529 13.715 21.6509 13.9568C21.6497 14.0981 21.6792 14.1959 21.7472 14.2772C21.9506 14.52 23.8626 14.2602 25.5115 14.2602C27.0142 14.2602 27.0339 14.259 27.1915 14.1602C27.4604 13.9915 27.5254 13.8177 27.4919 13.3569C27.3635 11.5861 26.5777 10.0751 25.1394 8.83368C24.7742 8.51846 24.4459 8.29343 23.9045 7.98733C23.6608 7.84955 23.4539 7.7297 23.4447 7.72107C23.4354 7.71239 23.5248 7.57513 23.6433 7.41598C23.9025 7.0678 24.1366 6.60065 24.2761 6.15276C24.4072 5.73245 24.4555 4.84231 24.3733 4.36401C24.1042 2.79774 22.8546 1.52015 21.2034 1.12302C20.6089 0.980039 19.6337 0.97929 19.1003 1.12139C18.6218 1.24886 18.2361 1.40317 17.8608 1.61727C17.6937 1.71262 17.5432 1.79034 17.5265 1.78999C17.5098 
1.78968 17.3588 1.67935 17.1911 1.54483C16.6122 1.08072 15.9103 0.741619 15.135 0.55149C14.6622 0.435563 13.6434 0.402031 13.171 0.486851ZM14.7508 1.65736C15.8456 1.86838 16.8082 2.5635 17.2879 3.48938C17.5529 4.00077 17.6604 4.43879 17.6604 5.00715C17.6604 6.05279 17.2485 6.83352 16.306 7.57421C15.8787 7.91009 15.7931 8.06303 15.8743 8.346C15.9421 8.58244 16.021 8.63743 16.6417 8.88083C17.3139 9.14441 17.6834 9.33709 18.1844 9.68554C19.36 10.5032 20.23 11.6236 20.6879 12.9097C20.8245 13.2931 20.9922 14.0045 20.9922 14.1999C20.9922 14.2507 19.8867 14.2602 14 14.2602H7.00777V14.168C7.00777 13.9757 7.20191 13.1927 7.34199 12.8199C7.87143 11.4111 8.89159 10.2135 10.2547 9.40081C10.6161 9.1853 10.8401 9.08025 11.4133 8.85721C11.9781 8.63747 12.0587 8.57962 12.1257 8.346C12.2065 8.06422 12.12 7.90622 11.7131 7.59271C11.0268 7.06388 10.5687 6.41031 10.4075 5.72994C10.2885 5.22768 10.3302 4.44474 10.501 3.97168C10.6702 3.50322 10.8587 3.17984 11.1669 2.82893C11.835 2.06846 12.924 1.58206 13.9765 1.57395C14.1572 1.57259 14.5056 1.61013 14.7508 1.65736ZM8.65259 2.25383C8.93125 2.32164 9.46566 2.55011 9.64952 2.68009C9.72897 2.73627 9.72339 2.76037 9.54849 3.11327C8.94293 4.33533 8.94476 5.74078 9.55337 6.87979C9.72184 7.19501 10.1066 7.72772 10.2699 7.87172C10.3341 7.92834 10.3866 7.988 10.3866 8.00434C10.3866 8.02065 10.2546 8.09837 10.0933 8.17707C9.93198 8.25581 9.59935 8.44571 9.35416 8.59914C7.83351 9.55062 6.69777 10.945 6.11624 12.5746L5.93139 13.0926L3.86507 13.104L1.7988 13.1155V13.0078C1.7988 12.9485 1.83005 12.7604 1.8683 12.5898C2.27333 10.782 3.75934 9.2109 5.72224 8.51524C6.1565 8.36134 6.26641 8.2503 6.29405 7.93746L6.3155 7.69459L5.87128 7.28719C5.14446 6.62066 4.86177 6.05666 4.81677 5.18339C4.78706 4.60653 4.87223 4.19772 5.12527 3.70238C5.52875 2.91252 6.37833 2.3298 7.33486 2.18686C7.68245 2.13491 8.29096 2.16584 8.65259 2.25383Z"
                fill="#67A110"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.171 0.486851C12.2755 0.647634 11.4744 1.00991 10.7797 1.56818C10.628 1.69006 10.4902 1.78999 10.4735 1.79021C10.4568 1.79043 10.3017 1.70997 10.1289 1.61136C9.37753 1.18277 8.73861 1.02177 7.80554 1.02591C7.20815 1.02855 7.07413 1.04336 6.70748 1.14708C5.91609 1.37105 5.34634 1.68111 4.82258 2.17289C4.18564 2.77095 3.76934 3.53371 3.62668 4.36401C3.54451 4.84231 3.59284 5.73245 3.72387 6.15276C3.86305 6.59946 4.09732 7.06758 4.35443 7.41294C4.47161 7.57037 4.56753 7.70565 4.56753 7.71362C4.56753 7.72155 4.38207 7.82854 4.15541 7.95138C2.0004 9.11916 0.672721 11.0868 0.508052 13.3569C0.47464 13.8177 0.539634 13.9915 0.80853 14.1602L0.967991 14.2602H3.36083H5.75368L5.72397 14.5356C5.68671 14.8805 5.74654 15.088 5.9312 15.2541L6.07537 15.3838H14H21.9246L22.0688 15.2541C22.2708 15.0724 22.3012 14.9214 22.2567 14.3207C22.1338 12.6604 21.4522 11.1816 20.1991 9.85703C19.6037 9.22755 18.685 8.55552 17.9067 8.18002C17.7454 8.10216 17.6134 8.02413 17.6134 8.00659C17.6134 7.98905 17.6659 7.92834 17.7301 7.87172C17.8946 7.72666 18.2793 7.1932 18.4456 6.87979C19.0551 5.73047 19.0578 4.32749 18.4526 3.11327C18.2377 2.68207 18.2188 2.72367 18.7438 2.47304C19.2292 2.24132 19.5759 2.16959 20.1945 2.17289C20.6429 2.17527 20.7976 2.19519 21.1095 2.29049C21.9071 2.53424 22.5343 3.0358 22.8747 3.70238C23.1275 4.19711 23.2128 4.60644 23.1836 5.18339C23.139 6.06371 22.8499 6.63542 22.1084 7.30904L21.6845 7.69423L21.7059 7.93728C21.734 8.25462 21.8361 8.35362 22.3221 8.53424C23.8251 9.09294 24.9757 10.0588 25.6527 11.3301C25.9553 11.8983 26.2012 12.6501 26.2012 13.0073V13.1146L25.2074 13.1149L25.0632 13.1149C24.0174 13.1152 21.8229 13.1866 21.6964 13.2649C21.5099 13.3803 21.6529 13.715 21.6509 13.9568C21.6497 14.0981 21.6792 14.1959 21.7472 14.2772C21.9506 14.52 23.8626 14.2602 25.5115 14.2602C27.0142 14.2602 27.0339 14.259 27.1915 14.1602C27.4604 13.9915 27.5254 13.8177 27.4919 13.3569C27.3635 11.5861 26.5777 10.0751 25.1394 8.83368C24.7742 8.51846 24.4459 8.29343 23.9045 7.98733C23.6608 7.84955 23.4539 7.7297 23.4447 7.72107C23.4354 7.71239 23.5248 7.57513 23.6433 7.41598C23.9025 7.0678 24.1366 6.60065 24.2761 6.15276C24.4072 5.73245 24.4555 4.84231 24.3733 4.36401C24.1042 2.79774 22.8546 1.52015 21.2034 1.12302C20.6089 0.980039 19.6337 0.97929 19.1003 1.12139C18.6218 1.24886 18.2361 1.40317 17.8608 1.61727C17.6937 1.71262 17.5432 1.79034 17.5265 1.78999C17.5098 1.78968 17.3588 1.67935 17.1911 1.54483C16.6122 
1.08072 15.9103 0.741619 15.135 0.55149C14.6622 0.435563 13.6434 0.402031 13.171 0.486851ZM14.7508 1.65736C15.8456 1.86838 16.8082 2.5635 17.2879 3.48938C17.5529 4.00077 17.6604 4.43879 17.6604 5.00715C17.6604 6.05279 17.2485 6.83352 16.306 7.57421C15.8787 7.91009 15.7931 8.06303 15.8743 8.346C15.9421 8.58244 16.021 8.63743 16.6417 8.88083C17.3139 9.14441 17.6834 9.33709 18.1844 9.68554C19.36 10.5032 20.23 11.6236 20.6879 12.9097C20.8245 13.2931 20.9922 14.0045 20.9922 14.1999C20.9922 14.2507 19.8867 14.2602 14 14.2602H7.00777V14.168C7.00777 13.9757 7.20191 13.1927 7.34199 12.8199C7.87143 11.4111 8.89159 10.2135 10.2547 9.40081C10.6161 9.1853 10.8401 9.08025 11.4133 8.85721C11.9781 8.63747 12.0587 8.57962 12.1257 8.346C12.2065 8.06422 12.12 7.90622 11.7131 7.59271C11.0268 7.06388 10.5687 6.41031 10.4075 5.72994C10.2885 5.22768 10.3302 4.44474 10.501 3.97168C10.6702 3.50322 10.8587 3.17984 11.1669 2.82893C11.835 2.06846 12.924 1.58206 13.9765 1.57395C14.1572 1.57259 14.5056 1.61013 14.7508 1.65736ZM8.65259 2.25383C8.93125 2.32164 9.46566 2.55011 9.64952 2.68009C9.72897 2.73627 9.72339 2.76037 9.54849 3.11327C8.94293 4.33533 8.94476 5.74078 9.55337 6.87979C9.72184 7.19501 10.1066 7.72772 10.2699 7.87172C10.3341 7.92834 10.3866 7.988 10.3866 8.00434C10.3866 8.02065 10.2546 8.09837 10.0933 8.17707C9.93198 8.25581 9.59935 8.44571 9.35416 8.59914C7.83351 9.55062 6.69777 10.945 6.11624 12.5746L5.93139 13.0926L3.86507 13.104L1.7988 13.1155V13.0078C1.7988 12.9485 1.83005 12.7604 1.8683 12.5898C2.27333 10.782 3.75934 9.2109 5.72224 8.51524C6.1565 8.36134 6.26641 8.2503 6.29405 7.93746L6.3155 7.69459L5.87128 7.28719C5.14446 6.62066 4.86177 6.05666 4.81677 5.18339C4.78706 4.60653 4.87223 4.19772 5.12527 3.70238C5.52875 2.91252 6.37833 2.3298 7.33486 2.18686C7.68245 2.13491 8.29096 2.16584 8.65259 2.25383Z"
                fill="#67A110"
            />
            <path
                d="M25.5115 14.2602C23.8626 14.2602 21.9506 14.52 21.7472 14.2772C21.6792 14.1959 21.6497 14.0981 21.6509 13.9568C21.6529 13.715 21.5099 13.3803 21.6964 13.2649C21.8229 13.1866 24.0174 13.1152 25.0632 13.1149L25.2074 13.1149M25.5115 14.2602C27.0142 14.2602 27.0339 14.259 27.1915 14.1602C27.4604 13.9915 27.5254 13.8177 27.4919 13.3569C27.3635 11.5861 26.5777 10.0751 25.1394 8.83368C24.7742 8.51846 24.4459 8.29343 23.9045 7.98733C23.6608 7.84955 23.4539 7.7297 23.4447 7.72107C23.4354 7.71239 23.5248 7.57513 23.6433 7.41598C23.9025 7.0678 24.1366 6.60065 24.2761 6.15276C24.4072 5.73245 24.4555 4.84231 24.3733 4.36401C24.1042 2.79774 22.8546 1.52015 21.2034 1.12302C20.6089 0.980039 19.6337 0.97929 19.1003 1.12139C18.6218 1.24886 18.2361 1.40317 17.8608 1.61727C17.6937 1.71262 17.5432 1.79034 17.5265 1.78999C17.5098 1.78968 17.3588 1.67935 17.1911 1.54483C16.6122 1.08072 15.9103 0.741619 15.135 0.55149C14.6622 0.435563 13.6434 0.402031 13.171 0.486851C12.2755 0.647634 11.4744 1.00991 10.7797 1.56818C10.628 1.69006 10.4902 1.78999 10.4735 1.79021C10.4568 1.79043 10.3017 1.70997 10.1289 1.61136C9.37753 1.18277 8.73861 1.02177 7.80554 1.02591C7.20815 1.02855 7.07413 1.04336 6.70748 1.14708C5.91609 1.37105 5.34634 1.68111 4.82258 2.17289C4.18564 2.77095 3.76934 3.53371 3.62668 4.36401C3.54451 4.84231 3.59284 5.73245 3.72387 6.15276C3.86305 6.59946 4.09732 7.06758 4.35443 7.41294C4.47161 7.57038 4.56753 7.70565 4.56753 7.71362C4.56753 7.72155 4.38207 7.82854 4.15541 7.95138C2.0004 9.11916 0.672721 11.0868 0.508052 13.3569C0.47464 13.8177 0.539634 13.9915 0.80853 14.1602L0.967991 14.2602H3.36083H5.75368L5.72397 14.5356C5.68671 14.8805 5.74654 15.088 5.9312 15.2541L6.07537 15.3838H14H21.9246L22.0688 15.2541C22.2708 15.0724 22.3012 14.9214 22.2567 14.3207C22.1338 12.6604 21.4522 11.1816 20.1991 9.85703C19.6037 9.22755 18.685 8.55552 17.9067 8.18002C17.7454 8.10216 17.6134 8.02413 17.6134 8.00659C17.6134 7.98905 17.6659 7.92834 17.7301 7.87172C17.8946 7.72666 18.2793 7.1932 18.4456 6.87979C19.0551 5.73047 19.0578 4.32749 18.4526 3.11327C18.2377 2.68207 18.2188 2.72367 18.7438 2.47304C19.2292 2.24132 
19.5759 2.16959 20.1945 2.17289C20.6429 2.17527 20.7976 2.19519 21.1095 2.29049C21.9071 2.53424 22.5343 3.0358 22.8747 3.70238C23.1275 4.19711 23.2128 4.60644 23.1836 5.18339C23.139 6.06371 22.8499 6.63542 22.1084 7.30904L21.6845 7.69423L21.7059 7.93728C21.734 8.25462 21.8361 8.35362 22.3221 8.53424C23.8251 9.09294 24.9757 10.0588 25.6527 11.3301C25.9553 11.8983 26.2012 12.6501 26.2012 13.0073V13.1146L25.2074 13.1149M25.5115 
14.2602C24.3892 14.2803 21.5279 14.3337 21.4672 14.2854C21.4065 14.2372 21.3131 13.5588 21.274 13.2256C22.3142 13.1971 25.0385 13.1149 25.2074 13.1149M14.7508 1.65736C15.8456 1.86838 16.8082 2.5635 17.2879 3.48938C17.5529 4.00077 17.6604 4.43879 17.6604 5.00715C17.6604 6.05279 17.2485 6.83352 16.306 7.57421C15.8787 7.91009 15.7931 8.06303 15.8743 8.346C15.9421 8.58244 16.021 8.63743 16.6417 8.88083C17.3139 9.14441 17.6834 9.33709 18.1844 9.68554C19.36 10.5032 20.23 11.6236 20.6879 12.9097C20.8245 13.2931 20.9922 14.0045 20.9922 14.1999C20.9922 14.2507 19.8867 14.2602 14 14.2602H7.00777V14.168C7.00777 13.9757 7.20191 13.1927 7.34199 12.8199C7.87143 11.4111 8.89159 10.2135 10.2547 9.40081C10.6161 9.1853 10.8401 9.08025 11.4133 8.85721C11.9781 8.63747 12.0587 8.57962 12.1257 8.346C12.2065 8.06422 12.12 7.90622 11.7131 7.59271C11.0268 7.06388 10.5687 6.41031 10.4075 5.72994C10.2885 5.22768 10.3302 4.44474 10.501 3.97168C10.6702 3.50322 10.8587 3.17984 11.1669 2.82893C11.835 2.06846 12.924 1.58206 13.9765 1.57395C14.1572 1.57259 14.5056 1.61013 14.7508 1.65736ZM8.65259 2.25383C8.93125 2.32164 9.46566 2.55011 9.64952 2.68009C9.72897 2.73627 9.72339 2.76037 9.54849 3.11327C8.94293 4.33533 8.94476 5.74078 9.55337 6.87979C9.72184 7.19501 10.1066 7.72772 10.2699 7.87172C10.3341 7.92834 10.3866 7.988 10.3866 8.00434C10.3866 8.02065 10.2546 8.09837 10.0933 8.17707C9.93198 8.25581 9.59936 8.44571 9.35416 8.59914C7.83351 9.55062 6.69777 10.945 6.11624 12.5746L5.93139 13.0926L3.86507 13.104L1.7988 13.1155V13.0078C1.7988 12.9485 1.83005 12.7604 1.8683 12.5898C2.27333 10.782 3.75934 9.2109 5.72224 8.51524C6.1565 8.36134 6.26641 8.2503 6.29405 7.93746L6.3155 7.69459L5.87128 7.28719C5.14446 6.62066 4.86177 6.05666 4.81677 5.18339C4.78706 4.60653 4.87223 4.19772 5.12527 3.70238C5.52875 2.91252 6.37833 2.3298 7.33486 2.18686C7.68245 2.13491 8.29096 2.16584 8.65259 2.25383Z"
                stroke="#67A110"
                strokeWidth="0.2"
            />
            <path
                d="M9.49999 3.85554C9.16176 4.19377 9.99132 5.98576 10.6587 7.23652C10.8552 7.60482 10.7952 8.06031 10.5 8.35547C10.3333 8.52214 9.7 9.05547 8.5 9.85547C7.41808 10.5767 6.79679 12.707 6.56285 13.9743C6.51866 14.2137 6.60131 14.4568 6.77346 14.6289C6.91851 14.774 7.11258 14.8554 7.31772 14.8556C12.0767 14.8601 21 14.9644 21 15.3555C21 15.6765 21.4293 14.9456 21.7712 14.2999C21.9184 14.0217 21.9172 13.6898 21.7764 13.4083L21.5403 12.9361C21.5135 12.8825 21.4819 12.8313 21.4459 12.7833L20.0701 10.9489C20.0235 10.8868 19.9699 10.8304 19.9103 10.7807L17.6084 8.8625C17.2519 8.56543 17.1467 8.06213 17.3542 7.64707L17.4682 7.41903C17.4894 7.37671 17.5075 7.33339 17.522 7.28836C17.6943 6.75469 18 5.62164 18 4.85547C18 3.85547 17.5 2.35554 16.5 1.85554C15.5 1.35554 13 0.855544 12 1.35554C11 1.85554 9.99999 3.35554 9.49999 3.85554Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="0.2"
            />
            <path
                d="M22.3995 14.1679C22.4883 14.0985 22.3302 13.6823 22.1942 13.4048C22.1333 13.2806 22.0337 13.1628 21.8954 13.1661C21.809 13.1682 21.7242 13.1959 21.6606 13.2277C21.5806 13.2677 21.5519 13.3542 21.5464 13.4435L21.5435 13.4898C21.5355 13.6162 21.5064 13.7507 21.414 13.8375C21.3906 13.8595 21.414 13.9697 21.4375 14.0358C21.5229 14.2765 21.767 14.4237 22.0224 14.4229C22.1141 14.4226 22.1886 14.4175 22.2118 14.4103C22.2822 14.3882 22.2587 14.2781 22.3995 14.1679Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="0.2"
            />
        </svg>
    ) : (
        <svg
            width="29"
            height="17"
            viewBox="0 0 29 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.671 1.05228C12.7755 1.21306 11.9744 1.57534 11.2797 2.13361C11.128 2.25549 10.9902 2.35542 10.9735 2.35564C10.9568 2.35586 10.8017 2.2754 10.6289 2.17679C9.87753 1.7482 9.23861 1.5872 8.30554 1.59134C7.70816 1.59398 7.57413 1.60879 7.20748 1.71251C6.41609 1.93648 5.84635 2.24654 5.32259 2.73832C4.68564 3.33638 4.26934 4.09914 4.12668 4.92944C4.04451 5.40774 4.09284 6.29788 4.22387 6.71819C4.36305 7.16489 4.59732 7.63301 4.85443 7.97837C4.97161 8.1358 5.06753 8.27108 5.06753 8.27905C5.06753 8.28698 4.88208 8.39397 4.65541 8.51681C2.5004 9.68459 1.17272 11.6523 1.00805 13.9224C0.97464 14.3832 1.03963 14.5569 1.30853 14.7256L1.46799 14.8256H3.86083H6.25368L6.22397 15.101C6.18671 15.4459 6.24654 15.6534 6.43121 15.8195L6.57537 15.9492H14.5H22.4246L22.5688 15.8195C22.7708 15.6378 22.8012 15.4868 22.7567 14.8861C22.6338 13.2259 21.9522 11.7471 20.6992 10.4225C20.1037 9.79298 19.185 9.12095 18.4067 8.74545C18.2454 
8.66759 18.1134 8.58956 18.1134 8.57202C18.1134 8.55448 18.1659 8.49377 18.2301 8.43715C18.3946 8.29209 18.7793 7.75863 18.9456 7.44522C19.5551 6.2959 19.5578 4.89292 18.9526 3.6787C18.7377 3.2475 18.7188 3.2891 19.2438 3.03847C19.7292 2.80675 20.0759 2.73502 20.6945 2.73832C21.1429 2.7407 21.2976 2.76062 21.6095 2.85592C22.4071 3.09967 23.0343 3.60123 23.3747 4.26781C23.6275 4.76254 23.7128 5.17187 23.6836 5.74882C23.639 6.62914 23.3499 7.20085 22.6084 7.87447L22.1845 8.25966L22.2059 8.50271C22.234 8.82005 22.3361 8.91905 22.8221 9.09966C24.3251 9.65837 25.4757 10.6242 26.1527 11.8955C26.4553 12.4638 26.7012 13.2156 26.7012 13.5727V13.68L25.7074 13.6803L25.5632 13.6803C24.5174 13.6806 22.3229 13.7521 22.1964 13.8303C22.0099 13.9458 22.1529 14.2804 22.1509 14.5223C22.1497 14.6635 22.1792 14.7613 22.2472 14.8426C22.4506 15.0854 24.3626 14.8256 26.0115 14.8256C27.5142 14.8256 27.5339 14.8244 27.6915 14.7256C27.9604 14.5569 28.0254 14.3832 27.9919 13.9224C27.8635 12.1515 27.0777 10.6406 25.6394 9.39911C25.2742 9.08389 24.9459 8.85886 24.4045 8.55276C24.1608 8.41498 23.9539 8.29513 23.9447 8.2865C23.9354 8.27782 24.0248 8.14056 24.1433 7.98141C24.4025 7.63323 24.6366 7.16608 24.7761 6.71819C24.9072 6.29788 24.9555 5.40774 24.8733 4.92944C24.6042 3.36317 23.3546 2.08558 21.7034 1.68845C21.1089 1.54547 20.1337 1.54472 19.6003 1.68682C19.1218 1.81429 18.7361 1.9686 18.3608 2.1827C18.1937 2.27805 18.0432 2.35577 18.0265 2.35542C18.0098 2.35511 17.8589 2.24478 17.6911 2.11026C17.1122 1.64615 16.4103 1.30705 15.635 1.11692C15.1622 
1.00099 14.1434 0.967461 13.671 1.05228ZM15.2508 2.22279C16.3456 2.43381 17.3082 3.12893 17.7879 4.05481C18.0529 4.5662 18.1604 5.00422 18.1604 5.57258C18.1604 6.61822 17.7485 7.39895 16.806 8.13964C16.3787 8.47552 16.2931 8.62846 16.3743 8.91143C16.4421 9.14787 16.521 9.20286 17.1417 9.44626C17.8139 9.70984 18.1834 9.90252 18.6844 10.251C19.86 11.0687 20.73 12.189 21.1879 13.4751C21.3245 13.8586 21.4922 14.5699 21.4922 14.7653C21.4922 14.8161 20.3867 14.8256 14.5 14.8256H7.50777V14.7334C7.50777 14.5411 7.70191 13.7581 7.84199 13.3853C8.37143 11.9765 9.39159 10.779 10.7547 9.96624C11.1161 9.75073 11.3401 9.64568 11.9133 9.42264C12.4781 9.2029 12.5587 9.14505 12.6257 8.91143C12.7065 8.62965 12.62 8.47165 12.2131 8.15814C11.5268 7.62931 11.0687 6.97574 10.9075 6.29537C10.7885 5.79311 10.8302 5.01017 11.001 4.53711C11.1702 4.06865 11.3587 3.74527 11.6669 3.39436C12.335 2.63389 13.424 2.14749 14.4765 2.13938C14.6572 2.13802 15.0056 2.17556 15.2508 2.22279ZM9.15259 2.81926C9.43125 2.88707 9.96566 3.11554 10.1495 3.24552C10.229 3.3017 10.2234 3.3258 10.0485 3.6787C9.44293 4.90076 9.44476 6.30621 10.0534 7.44522C10.2218 7.76044 10.6066 8.29315 10.7699 8.43715C10.8341 8.49377 10.8866 8.55343 10.8866 8.56977C10.8866 8.58608 10.7546 8.6638 10.5933 8.7425C10.432 8.82124 10.0994 9.01114 9.85416 9.16457C8.33351 10.116 7.19777 11.5104 6.61624 13.14L6.43139 13.658L4.36507 13.6694L2.2988 13.6809V13.5732C2.2988 13.5139 2.33005 13.3258 2.3683 13.1552C2.77333 11.3474 4.25934 9.77633 6.22224 9.08067C6.65651 8.92676 6.76641 8.81573 6.79405 8.50289L6.8155 8.26002L6.37128 7.85262C5.64446 7.18609 5.36177 6.62209 5.31677 5.74882C5.28706 5.17196 5.37223 4.76315 5.62527 4.26781C6.02875 3.47795 6.87833 2.89523 7.83486 2.75229C8.18245 2.70034 8.79097 2.73127 9.15259 2.81926Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.671 1.05228C12.7755 1.21306 11.9744 1.57534 11.2797 2.13361C11.128 2.25549 10.9902 2.35542 10.9735 2.35564C10.9568 2.35586 10.8017 2.2754 10.6289 2.17679C9.87753 1.7482 9.23861 1.5872 8.30554 1.59134C7.70816 1.59398 7.57413 1.60879 7.20748 1.71251C6.41609 1.93648 5.84635 2.24654 5.32259 2.73832C4.68564 3.33638 4.26934 4.09914 4.12668 4.92944C4.04451 5.40774 4.09284 6.29788 4.22387 6.71819C4.36305 7.16489 4.59732 7.63301 4.85443 7.97837C4.97161 8.1358 5.06753 8.27108 5.06753 8.27905C5.06753 8.28698 4.88208 8.39397 4.65541 8.51681C2.5004 9.68459 1.17272 11.6523 1.00805 13.9224C0.97464 14.3832 1.03963 14.5569 1.30853 14.7256L1.46799 14.8256H3.86083H6.25368L6.22397 15.101C6.18671 15.4459 6.24654 15.6534 6.43121 15.8195L6.57537 15.9492H14.5H22.4246L22.5688 15.8195C22.7708 15.6378 22.8012 15.4868 22.7567 14.8861C22.6338 13.2259 21.9522 11.7471 20.6992 10.4225C20.1037 9.79298 19.185 9.12095 18.4067 8.74545C18.2454 8.66759 18.1134 8.58956 18.1134 8.57202C18.1134 8.55448 18.1659 8.49377 18.2301 8.43715C18.3946 8.29209 18.7793 7.75863 18.9456 7.44522C19.5551 6.2959 19.5578 4.89292 18.9526 3.6787C18.7377 3.2475 18.7188 3.2891 19.2438 3.03847C19.7292 2.80675 20.0759 2.73502 20.6945 2.73832C21.1429 2.7407 21.2976 2.76062 21.6095 2.85592C22.4071 3.09967 23.0343 3.60123 23.3747 4.26781C23.6275 4.76254 23.7128 5.17187 23.6836 5.74882C23.639 6.62914 23.3499 7.20085 22.6084 7.87447L22.1845 8.25966L22.2059 8.50271C22.234 8.82005 22.3361 8.91905 22.8221 9.09966C24.3251 9.65837 25.4757 10.6242 26.1527 11.8955C26.4553 12.4638 26.7012 13.2156 26.7012 13.5727V13.68L25.7074 13.6803L25.5632 13.6803C24.5174 13.6806 22.3229 13.7521 22.1964 13.8303C22.0099 13.9458 22.1529 14.2804 22.1509 
14.5223C22.1497 14.6635 22.1792 14.7613 22.2472 14.8426C22.4506 15.0854 24.3626 14.8256 26.0115 14.8256C27.5142 14.8256 27.5339 14.8244 27.6915 14.7256C27.9604 14.5569 28.0254 14.3832 27.9919 13.9224C27.8635 12.1515 27.0777 10.6406 25.6394 9.39911C25.2742 9.08389 24.9459 8.85886 24.4045 8.55276C24.1608 8.41498 23.9539 8.29513 23.9447 8.2865C23.9354 8.27782 24.0248 8.14056 24.1433 7.98141C24.4025 7.63323 24.6366 7.16608 24.7761 6.71819C24.9072 6.29788 24.9555 5.40774 24.8733 4.92944C24.6042 3.36317 23.3546 2.08558 21.7034 1.68845C21.1089 1.54547 20.1337 1.54472 19.6003 1.68682C19.1218 1.81429 18.7361 1.9686 18.3608 2.1827C18.1937 2.27805 18.0432 2.35577 18.0265 2.35542C18.0098 2.35511 17.8589 2.24478 17.6911 2.11026C17.1122 1.64615 16.4103 1.30705 15.635 1.11692C15.1622 1.00099 14.1434 0.967461 13.671 1.05228ZM15.2508 2.22279C16.3456 2.43381 17.3082 3.12893 17.7879 4.05481C18.0529 4.5662 18.1604 5.00422 18.1604 5.57258C18.1604 6.61822 17.7485 7.39895 16.806 8.13964C16.3787 8.47552 16.2931 8.62846 16.3743 8.91143C16.4421 9.14787 16.521 9.20286 17.1417 9.44626C17.8139 9.70984 18.1834 9.90252 18.6844 10.251C19.86 11.0687 20.73 12.189 21.1879 
13.4751C21.3245 13.8586 21.4922 14.5699 21.4922 14.7653C21.4922 14.8161 20.3867 14.8256 14.5 14.8256H7.50777V14.7334C7.50777 14.5411 7.70191 13.7581 7.84199 13.3853C8.37143 11.9765 9.39159 10.779 10.7547 9.96624C11.1161 9.75073 11.3401 9.64568 11.9133 9.42264C12.4781 9.2029 12.5587 9.14505 12.6257 8.91143C12.7065 8.62965 12.62 8.47165 12.2131 8.15814C11.5268 7.62931 11.0687 6.97574 10.9075 6.29537C10.7885 5.79311 10.8302 5.01017 11.001 4.53711C11.1702 4.06865 11.3587 3.74527 11.6669 3.39436C12.335 2.63389 13.424 2.14749 14.4765 2.13938C14.6572 2.13802 15.0056 2.17556 15.2508 2.22279ZM9.15259 2.81926C9.43125 2.88707 9.96566 3.11554 10.1495 3.24552C10.229 3.3017 10.2234 3.3258 10.0485 3.6787C9.44293 4.90076 9.44476 6.30621 10.0534 7.44522C10.2218 7.76044 10.6066 8.29315 10.7699 8.43715C10.8341 8.49377 10.8866 8.55343 10.8866 8.56977C10.8866 8.58608 10.7546 8.6638 10.5933 8.7425C10.432 8.82124 10.0994 9.01114 9.85416 9.16457C8.33351 10.116 7.19777 11.5104 6.61624 13.14L6.43139 13.658L4.36507 13.6694L2.2988 13.6809V13.5732C2.2988 13.5139 2.33005 13.3258 2.3683 13.1552C2.77333 11.3474 4.25934 9.77633 6.22224 9.08067C6.65651 8.92676 6.76641 8.81573 6.79405 8.50289L6.8155 8.26002L6.37128 7.85262C5.64446 7.18609 5.36177 6.62209 5.31677 5.74882C5.28706 5.17196 5.37223 4.76315 5.62527 4.26781C6.02875 3.47795 6.87833 2.89523 7.83486 2.75229C8.18245 2.70034 8.79097 2.73127 9.15259 2.81926Z"
                fill="black"
            />
            <path
                d="M26.0115 14.8256C24.3626 14.8256 22.4506 15.0854 22.2472 14.8426C22.1792 14.7613 22.1497 14.6635 22.1509 14.5223C22.1529 14.2804 22.0099 13.9458 22.1964 13.8303C22.3229 13.7521 24.5174 13.6806 25.5632 13.6803L25.7074 13.6803M26.0115 14.8256C27.5142 14.8256 27.5339 14.8244 27.6915 14.7256C27.9604 14.5569 28.0254 14.3832 27.9919 13.9224C27.8635 12.1515 27.0777 10.6406 25.6394 9.39911C25.2742 9.08389 24.9459 8.85886 24.4045 8.55276C24.1608 8.41498 23.9539 8.29513 23.9447 8.2865C23.9354 8.27782 24.0248 8.14056 24.1433 7.98141C24.4025 7.63323 24.6366 7.16608 24.7761 6.71819C24.9072 6.29788 24.9555 5.40774 24.8733 4.92944C24.6042 3.36317 23.3546 2.08558 21.7034 1.68845C21.1089 1.54547 20.1337 1.54472 19.6003 1.68682C19.1218 1.81429 18.7361 1.9686 18.3608 2.1827C18.1937 2.27805 18.0432 2.35577 18.0265 2.35542C18.0098 2.35511 17.8589 2.24478 17.6911 2.11026C17.1122 1.64615 16.4103 1.30705 15.635 1.11692C15.1622 1.00099 14.1434 0.967461 13.671 1.05228C12.7755 1.21306 11.9744 1.57534 11.2797 2.13361C11.128 2.25549 10.9902 2.35542 10.9735 2.35564C10.9568 2.35586 10.8017 2.2754 10.6289 2.17679C9.87753 1.7482 9.23861 1.5872 8.30554 1.59134C7.70815 1.59398 7.57413 1.60879 7.20748 1.71251C6.41609 1.93648 5.84635 2.24654 5.32259 2.73832C4.68564 3.33638 4.26934 4.09914 4.12668 4.92944C4.04451 5.40774 4.09284 6.29788 4.22387 6.71819C4.36305 7.16489 4.59732 7.63301 4.85443 7.97837C4.97161 8.1358 5.06753 8.27108 5.06753 8.27905C5.06753 8.28698 4.88207 8.39397 4.65541 8.51681C2.5004 9.68459 1.17272 11.6523 1.00805 13.9224C0.97464 14.3832 1.03963 14.5569 1.30853 14.7256L1.46799 14.8256H3.86083H6.25368L6.22397 15.101C6.18671 15.4459 6.24655 15.6534 6.43121 
15.8195L6.57537 15.9492H14.5H22.4246L22.5688 15.8195C22.7708 15.6378 22.8012 15.4868 22.7567 14.8861C22.6338 13.2259 21.9522 11.7471 20.6992 10.4225C20.1037 9.79298 19.185 9.12095 18.4067 8.74545C18.2454 8.66759 18.1134 8.58956 18.1134 8.57202C18.1134 8.55448 18.1659 8.49377 18.2301 8.43715C18.3946 8.29209 18.7793 7.75863 18.9456 7.44522C19.5551 6.2959 19.5578 4.89292 18.9526 3.6787C18.7377 3.2475 18.7188 3.2891 19.2438 3.03847C19.7292 2.80675 20.0759 2.73502 20.6945 2.73832C21.1429 2.7407 21.2976 2.76062 21.6095 2.85592C22.4071 3.09967 23.0343 3.60123 23.3747 4.26781C23.6275 4.76254 23.7128 5.17187 23.6836 5.74882C23.639 6.62914 23.3499 7.20085 22.6084 7.87447L22.1845 8.25966L22.2059 8.50271C22.234 8.82005 22.3361 8.91905 22.8221 9.09966C24.3251 9.65837 25.4757 10.6242 26.1527 11.8955C26.4553 12.4638 26.7012 13.2156 26.7012 13.5727V13.68L25.7074 13.6803M26.0115 14.8256C24.8892 14.8457 22.0279 14.8991 21.9672 14.8509C21.9065 14.8026 21.8131 14.1242 21.774 13.791C22.8142 13.7625 25.5385 13.6803 25.7074 13.6803M15.2508 2.22279C16.3456 2.43381 17.3082 3.12893 17.7879 4.05481C18.0529 4.5662 18.1604 5.00422 18.1604 5.57258C18.1604 6.61822 17.7485 7.39895 16.806 8.13964C16.3787 8.47552 16.2931 8.62846 16.3743 8.91143C16.4421 9.14787 16.521 9.20286 17.1417 9.44626C17.8139 9.70984 18.1834 9.90252 18.6844 10.251C19.86 11.0687 20.73 12.189 21.1879 13.4751C21.3245 13.8586 21.4922 14.5699 21.4922 14.7653C21.4922 14.8161 20.3867 14.8256 14.5 14.8256H7.50777V14.7334C7.50777 14.5411 7.70191 13.7581 7.84199 13.3853C8.37143 11.9765 9.39159 10.779 10.7547 9.96624C11.1161 9.75073 11.3401 9.64568 11.9133 9.42264C12.4781 9.2029 12.5587 9.14505 12.6257 8.91143C12.7065 8.62965 12.62 8.47165 12.2131 8.15814C11.5268 7.62931 11.0687 6.97574 10.9075 6.29537C10.7885 5.79311 10.8302 5.01017 11.001 4.53711C11.1702 4.06865 11.3587 3.74527 11.6669 3.39436C12.335 2.63389 13.424 2.14749 14.4765 
2.13938C14.6572 2.13802 15.0056 2.17556 15.2508 2.22279ZM9.15259 2.81926C9.43125 2.88707 9.96566 3.11554 10.1495 3.24552C10.229 3.3017 10.2234 3.3258 10.0485 3.6787C9.44293 4.90076 9.44476 6.30621 10.0534 7.44522C10.2218 7.76044 10.6066 8.29315 10.7699 8.43715C10.8341 8.49377 10.8866 8.55343 10.8866 8.56977C10.8866 8.58608 10.7546 8.6638 10.5933 8.7425C10.432 8.82124 10.0994 9.01114 9.85416 9.16457C8.33351 10.116 7.19777 11.5104 6.61624 13.14L6.43139 13.658L4.36507 13.6694L2.2988 13.6809V13.5732C2.2988 13.5139 2.33005 13.3258 2.3683 13.1552C2.77333 11.3474 4.25934 9.77633 6.22224 9.08067C6.65651 8.92676 6.76641 8.81573 6.79405 8.50289L6.8155 8.26002L6.37128 7.85262C5.64446 7.18609 5.36177 6.62209 5.31677 5.74882C5.28706 5.17196 5.37223 4.76315 5.62527 4.26781C6.02875 3.47795 6.87833 2.89523 7.83486 2.75229C8.18245 2.70034 8.79096 2.73127 9.15259 2.81926Z"
                stroke="black"
                strokeWidth="0.2"
            />
            <path
                d="M22.8995 14.7334C22.9883 14.6639 22.8302 14.2478 22.6942 13.9703C22.6333 13.846 22.5337 13.7283 22.3954 13.7316C22.309 13.7336 22.2242 13.7613 22.1606 13.7931C22.0806 13.8332 22.0519 13.9196 22.0464 14.0089L22.0435 14.0552C22.0355 14.1817 22.0064 14.3162 21.914 14.4029C21.8906 14.4249 21.914 14.5351 21.9375 14.6012C22.0229 14.8419 22.267 14.9891 22.5224 14.9883C22.6141 14.988 22.6886 14.983 22.7118 14.9757C22.7822 14.9537 22.7587 14.8435 22.8995 14.7334Z"
                fill="black"
                stroke="black"
                strokeWidth="0.2"
            />
        </svg>
    );
}

function AimhBuildingIcon({ isActive }) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.898438 16.875H18.3984"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.8984 16.875V3.125C10.8984 2.95924 10.8326 2.80027 10.7154 2.68306C10.5982 2.56585 10.4392 2.5 10.2734 2.5H2.77344C2.60768 2.5 2.44871 2.56585 2.3315 2.68306C2.21429 2.80027 2.14844 2.95924 2.14844 3.125V16.875"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.1484 16.875V8.125C17.1484 7.95924 17.0826 7.80027 16.9654 7.68306C16.8482 7.56585 16.6892 7.5 16.5234 7.5H10.8984"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.64844 5.625H7.14844"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.89844 10.625H8.39844"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.64844 13.75H7.14844"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3984 13.75H14.6484"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3984 10.625H14.6484"
                stroke={
                    isActive === "Property Description" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhEmailIcon({ isActive }) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.3242 4.375L9.82422 11.25L2.32422 4.375"
                stroke={isActive === "Marketing Emails" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.32422 4.375H17.3242V15C17.3242 15.1658 17.2584 15.3247 17.1412 15.4419C17.024 15.5592 16.865 15.625 16.6992 15.625H2.94922C2.78346 15.625 2.62449 15.5592 2.50728 15.4419C2.39007 15.3247 2.32422 15.1658 2.32422 15V4.375Z"
                stroke={isActive === "Marketing Emails" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.45703 10L2.51953 15.4453"
                stroke={isActive === "Marketing Emails" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.1289 15.4453L11.1914 10"
                stroke={isActive === "Marketing Emails" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhSocialMediaIcon({ isActive }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                stroke={
                    isActive === "Social Media Captions" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.75 8.25002H14.25C13.9542 8.24878 13.6611 8.30613 13.3875 8.41876C13.114 8.5314 12.8654 8.69708 12.6563 8.90626C12.4471 9.11544 12.2814 9.36397 12.1688 9.63752C12.0561 9.91106 11.9988 10.2042 12 10.5V21"
                stroke={
                    isActive === "Social Media Captions" ? "#67A110" : "#464646"
                }
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 13.5H15"
                stroke={
                    isActive === "Social Media Captions" ? "#67A110" : "#464646"
                }
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhAgentsBioIcon({ isActive }) {
    return (
        <svg
            width={44}
            height={40}
            viewBox="0 0 44 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.3125 20.7812C19.4699 20.7812 21.2188 19.0324 21.2188 16.875C21.2188 14.7176 19.4699 12.9688 17.3125 12.9688C15.1551 12.9688 13.4062 14.7176 13.4062 16.875C13.4062 19.0324 15.1551 20.7812 17.3125 20.7812Z"
                stroke={isActive === "Agent's Bio" ? "#67A110" : "#464646"}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.3438 15.3125H33.7188"
                stroke={isActive === "Agent's Bio" ? "#67A110" : "#464646"}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.3438 20H33.7188"
                stroke={isActive === "Agent's Bio" ? "#67A110" : "#464646"}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.6875 24.6875H33.7188"
                stroke={isActive === "Agent's Bio" ? "#67A110" : "#464646"}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.0625 27.0312C11.4178 25.2434 12.2249 23.6587 13.3565 22.5271C14.4882 21.3955 15.88 20.7812 17.3125 20.7812C18.745 20.7812 20.1368 21.3955 21.2685 22.5271C22.4001 23.6587 23.2072 25.2434 23.5625 27.0312"
                stroke={isActive === "Agent's Bio" ? "#67A110" : "#464646"}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhHistoryIcon({ isActive }) {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.25 6.65625V10.5"
                stroke={isActive === "History" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5813 12.4219L10.25 10.5"
                stroke={isActive === "History" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.75 8.2334H2.54688V5.03027"
                stroke={isActive === "History" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.26953 15.4809C6.25483 16.467 7.51045 17.1387 8.87756 17.4111C10.2447 17.6834 11.6619 17.5442 12.9499 17.011C14.2378 16.4778 15.3387 15.5746 16.1133 14.4156C16.8879 13.2567 17.3013 11.894 17.3013 10.5C17.3013 9.10602 16.8879 7.74335 16.1133 6.58437C15.3387 5.42539 14.2378 4.52218 12.9499 3.98899C11.6619 3.4558 10.2447 3.31658 8.87756 3.58895C7.51045 3.86132 6.25483 4.53305 5.26953 5.51914L2.54688 8.23379"
                stroke={isActive === "History" ? "#67A110" : "#464646"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function RewriteContentIcon({ isActive }) {
    return (
        <svg
            width={20}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.817 8.724c-.115 4.474-3.649 8.052-7.975 8.052a7.726 7.726 0 0 1-4.173-1.225l.885-.917c.974.562 2.093.89 3.288.89 3.676 0 6.667-3.038 6.782-6.8h1.193Zm-1.414-.448h-1.202l2.022-2.794 2.022 2.794H16.403ZM9.842.224a7.726 7.726 0 0 1 4.173 1.225l-.885.916a6.553 6.553 0 0 0-3.288-.889c-3.676 0-6.667 3.037-6.782 6.8H1.867C1.981 3.8 5.515.224 9.842.224ZM2.46 11.518.438 8.724h4.045L2.46 11.518Z"
                fill={isActive === "Rewrite Content" ? "#67A110" : "#000"}
                stroke={isActive === "Rewrite Content" ? "#67A110" : "#F6FCEE"}
                strokeWidth={0.448}
            />
            <rect
                x={6.471}
                y={4.539}
                width={7.28}
                height={8.318}
                rx={0.395}
                stroke={isActive === "Rewrite Content" ? "#67A110" : "#000"}
                strokeWidth={0.5}
            />
            <path
                d="M7.654 6.364h4.81M7.654 7.92h3.498M7.654 9.476h4.81M7.654 11.032h3.498"
                stroke={isActive === "Rewrite Content" ? "#67A110" : "#000"}
                strokeWidth={0.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhBullHornIcon({ isActive }) {
    return aiMhIsActives.includes(isActive) ? (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.8744 0.0636838C19.699 0.148447 19.5238 0.334412 19.4686 0.494257C19.4471 0.55678 19.4189 0.726115 19.406 0.87055C19.3417 1.58968 18.9398 2.17847 18.0652 2.83484C16.4262 4.06475 13.027 5.20324 9.10277 5.8366L8.70736 5.90042L6.58648 5.91686C5.42 5.92589 4.43865 5.93977 4.4057 5.9477C4.37275 5.95561 4.24873 5.97876 4.13011 5.99913C1.98479 6.36749 0.307577 8.13062 0.0303303 10.3089C-0.0191567 10.6977 -0.00638351 11.4153 0.0562361 11.7635C0.418797 13.7798 1.8636 15.3259 3.81857 15.7895C3.97673 15.827 4.15632 15.8645 4.21765 15.8727C4.30627 15.8846 4.33179 15.8985 4.34195 15.9405C4.34898 15.9695 
4.67363 17.6594 5.06339 19.6958C5.45315 21.7322 5.78841 23.4425 5.8084 23.4966C5.86201 23.6413 5.98799 23.7745 6.15929 23.8673L6.31089 23.9495H7.44921H8.58753L8.70887 23.8855C8.86011 23.8057 8.99433 23.6593 9.07219 23.4892C9.1306 23.3616 9.13795 23.2753 9.39195 19.7358C9.53493 17.7433 9.65238 16.1094 9.65293 16.105C9.65777 16.0669 11.3133 16.4134 12.2781 16.6544C15.2487 17.3965 17.4566 18.3645 18.5482 19.4033C19.0981 19.9267 19.3584 20.4114 19.4066 21.0019C19.4332 21.3285 19.4908 21.4805 19.6472 21.6369C20.0276 22.0173 20.6382 21.9039 20.873 21.4093L20.9413 21.2655L20.9413 17.9907L20.9413 14.7159L21.0671 14.6862C21.6903 14.539 22.3502 14.1788 22.8163 13.7317C23.4183 13.1541 23.7906 12.4816 23.9529 11.6788C24.0207 11.3433 24.0142 10.5677 23.9408 10.2298C23.7127 9.18022 23.1104 8.29777 22.2354 7.73129C21.8913 7.50854 21.5761 7.36643 21.181 7.25598L20.9533 7.19233L20.9413 3.86419L20.9293 0.536051L20.8744 0.433123C20.7937 0.282098 20.6731 0.158776 20.5295 0.0806268C20.4267 0.0246694 20.3664 0.00995506 20.2107 0.00276567C20.0377 -0.0051906 20.0043 0.000848487 19.8744 0.0636838ZM19.3983 18.1553C19.3931 18.1605 19.2934 18.0878 19.1766 17.9938C17.5749 16.7047 14.588 15.5536 11.008 14.8456C10.5113 14.7473 9.77385 14.6153 9.72199 14.6153C9.71085 14.6153 9.70448 12.9691 9.70781 10.9571L9.71387 7.2988L10.1213 7.22974C12.1035 6.89363 14.1839 6.34134 15.8368 5.71242C17.1836 5.19998 18.4775 4.49714 19.2518 
3.85738L19.3956 3.73859L19.4016 10.9423C19.4049 14.9043 19.4035 18.1502 19.3983 18.1553ZM8.16815 10.9498V14.4498L6.35283 14.4414L4.53751 14.433L4.28588 14.3705C3.59464 14.1988 3.03713 13.893 2.57099 13.4298C2.17907 13.0403 1.9336 12.6646 1.748 12.1701C1.58192 11.7276 1.54192 11.4882 1.54192 10.9367C1.54192 10.4092 1.56658 10.2377 1.70213 9.82235C2.03675 8.79707 2.85298 7.97684 3.88025 7.63349C4.08491 7.5651 4.37081 7.50339 4.61359 7.47516C4.70356 7.46471 5.54011 7.45474 6.47265 7.45299L8.16815 7.44985V10.9498ZM21.1223 8.85334C21.6191 9.07308 22.102 9.57367 22.306 10.0806C22.4455 10.4271 22.4632 10.5249 22.4613 10.9367C22.4599 11.2528 22.4503 11.3538 22.4071 11.5119C22.2295 12.1618 21.7612 12.7189 21.1654 12.9891C21.0823 13.0267 20.9978 13.0576 20.9778 13.0576C20.9454 13.0576 20.9413 12.8183 20.9413 10.9247C20.9413 9.72086 20.9504 8.79187 20.9623 8.79187C20.9738 8.79187 21.0458 8.81953 21.1223 8.85334ZM8.1572 16.1071C8.13908 16.3162 7.71282 22.3924 7.71282 22.4414C7.71282 22.469 7.66257 22.4757 7.45384 22.4757H7.19485L6.59017 19.2465C6.25759 17.4704 5.98591 15.9983 5.98643 15.9753C5.98732 15.936 6.05571 15.9333 7.0798 15.9333H8.17225L8.1572 16.1071Z"
                fill="#67A110"
            />
            <path
                d="M4.00088 7C1.60088 7 1.00088 9.33333 1.00088 10.5C0.579473 12.3597 2.00088 13.5 2.50088 14C2.90088 14.4 4.00088 14.8333 4.50088 15H8.50088C8.66755 13.1667 9.00088 9.4 9.00088 9C9.00088 8.6 8.66755 7.5 8.50088 7H7.50088H4.00088Z"
                fill="#67A110"
            />
        </svg>
    ) : (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.8744 0.0636838C19.699 0.148447 19.5238 0.334413 19.4686 0.494257C19.4471 0.556781 19.4189 0.726115 19.406 0.87055C19.3417 1.58968 18.9398 2.17847 18.0652 2.83484C16.4262 4.06475 13.027 5.20324 9.10277 5.8366L8.70736 5.90042L6.58648 5.91686C5.42 5.92589 4.43865 5.93977 4.4057 5.9477C4.37275 5.95561 4.24873 5.97876 4.13011 5.99913C1.98479 6.36749 0.307577 8.13062 0.0303303 10.3089C-0.0191567 10.6977 -0.0063835 11.4153 0.0562361 11.7635C0.418797 13.7798 1.8636 15.3259 3.81857 15.7895C3.97673 15.827 4.15632 15.8645 4.21765 15.8727C4.30627 15.8846 4.33179 15.8985 4.34195 15.9405C4.34898 15.9695 4.67363 17.6594 5.06339 19.6958C5.45315 21.7322 5.78841 23.4425 5.8084 23.4966C5.86201 23.6413 5.98799 23.7745 6.15929 23.8673L6.31089 23.9495H7.44921H8.58753L8.70887 23.8855C8.86011 23.8057 8.99433 23.6593 9.07219 23.4892C9.1306 23.3616 9.13795 23.2753 9.39195 19.7358C9.53493 17.7433 9.65238 16.1094 9.65293 16.105C9.65777 16.0669 11.3133 16.4134 12.2781 16.6544C15.2487 17.3965 17.4566 18.3645 18.5482 19.4033C19.0981 19.9267 19.3584 20.4114 19.4066 21.0019C19.4332 21.3285 19.4908 21.4805 19.6472 21.6369C20.0276 22.0173 20.6382 21.9039 20.873 21.4093L20.9413 21.2655L20.9413 17.9907L20.9413 14.7159L21.0671 14.6862C21.6903 14.539 22.3502 14.1788 22.8163 13.7317C23.4183 13.1541 23.7906 12.4816 23.9529 11.6788C24.0207 11.3433 24.0142 10.5677 23.9408 10.2298C23.7127 9.18022 23.1104 8.29777 22.2354 7.73129C21.8913 7.50854 21.5761 7.36643 21.181 7.25598L20.9533 7.19233L20.9413 3.86419L20.9293 0.536051L20.8744 0.433123C20.7937 0.282098 20.6731 0.158776 20.5295 0.0806269C20.4267 0.0246694 20.3664 0.00995507 20.2107 0.00276567C20.0377 -0.00519059 20.0043 0.00084845 19.8744 0.0636838ZM19.3983 18.1553C19.3931 18.1605 19.2934 18.0878 19.1766 17.9938C17.5749 16.7047 14.588 15.5536 11.008 14.8456C10.5113 14.7473 9.77385 14.6153 9.72199 14.6153C9.71085 14.6153 9.70448 12.9691 9.70781 10.9571L9.71387 7.2988L10.1213 7.22974C12.1035 6.89363 14.1839 6.34134 15.8368 5.71242C17.1836 5.19998 18.4775 4.49714 19.2518 3.85738L19.3956 3.73859L19.4016 10.9423C19.4049 14.9043 19.4034 18.1502 19.3983 18.1553ZM8.16815 10.9498V14.4498L6.35283 14.4414L4.53751 14.433L4.28588 14.3705C3.59464 14.1988 3.03713 13.893 2.57099 13.4298C2.17907 13.0403 1.9336 12.6646 1.748 12.1701C1.58192 11.7276 1.54192 
11.4882 1.54192 10.9367C1.54192 10.4092 1.56658 10.2377 1.70213 9.82235C2.03675 8.79707 2.85298 7.97684 3.88025 7.63349C4.08491 7.5651 4.37081 7.50339 4.61359 7.47516C4.70356 7.46471 5.54011 7.45474 6.47265 7.45299L8.16815 7.44985V10.9498ZM21.1223 8.85334C21.6191 9.07307 22.102 9.57367 22.306 10.0806C22.4455 10.4271 22.4632 10.5249 22.4613 10.9367C22.4599 11.2528 22.4503 11.3538 22.4071 11.5119C22.2295 12.1618 21.7612 12.7189 21.1654 12.9891C21.0823 13.0267 20.9978 13.0576 20.9778 13.0576C20.9454 13.0576 20.9413 12.8183 20.9413 10.9247C20.9413 9.72086 20.9504 8.79187 20.9623 8.79187C20.9738 8.79187 21.0458 8.81953 21.1223 8.85334ZM8.1572 16.1071C8.13908 16.3162 7.71282 22.3924 7.71282 22.4414C7.71282 22.469 7.66257 22.4757 7.45384 22.4757H7.19485L6.59017 19.2465C6.25759 17.4704 5.98591 15.9983 5.98643 15.9753C5.98732 15.936 6.05571 15.9333 7.0798 15.9333H8.17225L8.1572 16.1071Z"
                fill="black"
            />
        </svg>
    );
}

function TopbarProfileIcon({ isActive }) {
    return isActive === "My Profile" ? (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1.1a9.901 9.901 0 1 0 .002 19.803A9.901 9.901 0 0 0 11 1.1Zm0 2.96a3.275 3.275 0 1 1 .002 6.55A3.275 3.275 0 0 1 11 4.06ZM11 18.316a7.267 7.267 0 0 1-4.733-1.745 1.396 1.396 0 0 1-.49-1.06 3.303 3.303 0 0 1 3.32-3.303h3.81a3.299 3.299 0 0 1 3.315 3.302 1.392 1.392 0 0 1-.49 1.06A7.265 7.265 0 0 1 11 18.315Z"
                stroke="#707070"
                strokeWidth={1.057}
            />
        </svg>
    ) : (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1.1a9.901 9.901 0 1 0 .002 19.803A9.901 9.901 0 0 0 11 1.1Zm0 2.96a3.275 3.275 0 1 1 .002 6.55A3.275 3.275 0 0 1 11 4.06ZM11 18.316a7.267 7.267 0 0 1-4.733-1.745 1.396 1.396 0 0 1-.49-1.06 3.303 3.303 0 0 1 3.32-3.303h3.81a3.299 3.299 0 0 1 3.315 3.302 1.392 1.392 0 0 1-.49 1.06A7.265 7.265 0 0 1 11 18.315Z"
                stroke="#707070"
                strokeWidth={1.057}
            />
        </svg>
    );
}

function TopbarCouponIcon({ isActive }) {
    return isActive === "Coupons" ? (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 7.5H3.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75ZM19.5 12v6.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12M12 7.5v12M16.247 6.44C15.178 7.5 12 7.5 12 7.5s0-3.178 1.06-4.247a2.254 2.254 0 0 1 3.187 3.188v0ZM7.753 6.44C8.822 7.5 12 7.5 12 7.5s0-3.178-1.06-4.247a2.254 2.254 0 1 0-3.187 3.188v0Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 7.5H3.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75ZM19.5 12v6.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12M12 7.5v12M16.247 6.44C15.178 7.5 12 7.5 12 7.5s0-3.178 1.06-4.247a2.254 2.254 0 0 1 3.187 3.188v0ZM7.753 6.44C8.822 7.5 12 7.5 12 7.5s0-3.178-1.06-4.247a2.254 2.254 0 1 0-3.187 3.188v0Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function TopbarReferIcon({ isActive }) {
    return isActive === "Referrals" ? (
        <svg
            width={24}
            height={23}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.625 6.25c-.184 2.295-2.063 4.167-4.126 4.167-2.062 0-3.944-1.872-4.124-4.167-.188-2.387 1.64-4.167 4.124-4.167 2.485 0 4.313 1.823 4.126 4.167Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5 13.194c-4.079 0-8.218 2.084-8.984 6.016-.093.474.198.929.734.929h16.5c.536 0 .826-.455.733-.929-.766-3.932-4.905-6.016-8.984-6.016Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeMiterlimit={10}
            />
            <path
                d="M4.125 7.639V12.5M6.75 10.07H1.5"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={24}
            height={23}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.625 6.25c-.184 2.295-2.063 4.167-4.126 4.167-2.062 0-3.944-1.872-4.124-4.167-.188-2.387 1.64-4.167 4.124-4.167 2.485 0 4.313 1.823 4.126 4.167Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5 13.194c-4.079 0-8.218 2.084-8.984 6.016-.093.474.198.929.734.929h16.5c.536 0 .826-.455.733-.929-.766-3.932-4.905-6.016-8.984-6.016Z"
                stroke="#707070"
                strokeWidth={1.2}
                strokeMiterlimit={10}
            />
            <path
                d="M4.125 7.639V12.5M6.75 10.07H1.5"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function TopbarSupportIcon({ isActive }) {
    return isActive === "Support" ? (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.14 12h-3a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V12Zm0 0a8.999 8.999 0 0 0-9.074-9A9 9 0 0 0 3 12v5.25a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5V13.5A1.5 1.5 0 0 0 6 12H3"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.14 17.25v2.25a3 3 0 0 1-3 3h-5.39"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.14 12h-3a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V12Zm0 0a8.999 8.999 0 0 0-9.074-9A9 9 0 0 0 3 12v5.25a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5V13.5A1.5 1.5 0 0 0 6 12H3"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.14 17.25v2.25a3 3 0 0 1-3 3h-5.39"
                stroke="#707070"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function StyleGuideIcon({ isActive }) {
    return isActive === "Style Guide" ? (
        <svg
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.6375 12.1992H2.25C1.85218 12.1992 1.47064 12.0412 1.18934 11.7599C0.908035 11.4786 0.75 11.097 0.75 10.6992V3.94922C0.75 3.15357 1.06607 2.39051 1.62868 1.8279C2.19129 1.26529 2.95435 0.949219 3.75 0.949219H17.25V10.6992C17.25 11.097 17.092 11.4786 16.8107 11.7599C16.5294 12.0412 16.1478 12.1992 15.75 12.1992H11.3625C11.2555 12.1995 11.1498 12.2228 11.0525 12.2673C10.9552 12.3119 10.8685 12.3767 10.7984 12.4575C10.7282 12.5384 10.6762 12.6332 10.6457 12.7358C10.6153 12.8384 10.6072 12.9463 10.6219 13.0523L11.25 17.4492C11.25 18.046 11.0129 18.6183 10.591 19.0402C10.169 19.4622 9.59674 19.6992 9 19.6992C8.40326 19.6992 7.83097 19.4622 7.40901 19.0402C6.98705 18.6183 6.75 18.046 6.75 17.4492L7.37812 13.0523C7.39284 12.9463 7.3847 12.8384 7.35425 12.7358C7.32381 12.6332 7.27176 12.5384 7.20161 12.4575C7.13145 12.3767 7.04481 12.3119 6.94752 12.2673C6.85022 12.2228 6.74451 12.1995 6.6375 12.1992Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.75 10.5H20.25"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.6375 14.25H5.25C4.85218 14.25 4.47064 14.092 4.18934 13.8107C3.90804 13.5294 3.75 13.1478 3.75 12.75V6C3.75 5.20435 4.06607 4.44129 4.62868 3.87868C5.19129 3.31607 5.95435 3 6.75 3H20.25V12.75C20.25 13.1478 20.092 13.5294 19.8107 13.8107C19.5294 14.092 19.1478 14.25 18.75 14.25H14.3625C14.2555 14.2503 14.1498 14.2735 14.0525 14.3181C13.9552 14.3627 13.8685 14.4275 13.7984 14.5083C13.7282 14.5891 13.6762 14.684 13.6457 14.7866C13.6153 14.8892 13.6072 14.9971 13.6219 15.1031L14.25 19.5C14.25 20.0967 14.0129 20.669 13.591 21.091C13.169 21.5129 12.5967 21.75 12 21.75C11.4033 21.75 10.831 21.5129 10.409 21.091C9.98705 20.669 9.75 20.0967 9.75 19.5L10.3781 15.1031C10.3928 14.9971 10.3847 14.8892 10.3543 14.7866C10.3238 14.684 10.2718 14.5891 10.2016 14.5083C10.1315 14.4275 10.0448 14.3627 9.94752 14.3181C9.85022 14.2735 9.74451 14.2503 9.6375 14.25V14.25Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.25 3V7.5"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function CreateVideosIcon({ isActive }) {
    return isActive === "Create Videos" ? (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.25 3.91211V9.16211H19.5"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 21.9121H18.75C18.9489 21.9121 19.1397 21.8331 19.2803 21.6924C19.421 21.5518 19.5 21.361 19.5 21.1621V9.16211L14.25 3.91211H5.25C5.05109 3.91211 4.86032 3.99113 4.71967 4.13178C4.57902 4.27243 4.5 4.4632 4.5 4.66211V12.9121"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.75 15.9121H4.5C4.08579 15.9121 3.75 16.2479 3.75 16.6621V20.4121C3.75 20.8263 4.08579 21.1621 4.5 21.1621H9.75C10.1642 21.1621 10.5 20.8263 10.5 20.4121V16.6621C10.5 16.2479 10.1642 15.9121 9.75 15.9121Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 17.7871L13.5 16.2871V20.8996L10.5 19.2871"
                fill="#67A110"
            />
            <path
                d="M10.5 17.7871L13.5 16.2871V20.8996L10.5 19.2871"
                stroke="#67A110"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.25 3.00488V8.25488H19.5"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 21.0049H18.75C18.9489 21.0049 19.1397 20.9259 19.2803 20.7852C19.421 20.6446 19.5 20.4538 19.5 20.2549V8.25488L14.25 3.00488H5.25C5.05109 3.00488 4.86032 3.0839 4.71967 3.22455C4.57902 3.36521 4.5 3.55597 4.5 3.75488V12.0049"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.75 15.0049H4.5C4.08579 15.0049 3.75 15.3407 3.75 15.7549V19.5049C3.75 19.9191 4.08579 20.2549 4.5 20.2549H9.75C10.1642 20.2549 10.5 19.9191 10.5 19.5049V15.7549C10.5 15.3407 10.1642 15.0049 9.75 15.0049Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 16.8799L13.5 15.3799V19.9924L10.5 18.3799"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AimhHomeIcon({ isActive }) {
    return isActive === "Ai Marketinghub" ? (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.875 16.2498V12.4998C11.875 12.334 11.8092 12.1751 11.6919 12.0579C11.5747 11.9406 11.4158 11.8748 11.25 11.8748H8.75C8.58424 11.8748 8.42527 11.9406 8.30806 12.0579C8.19085 12.1751 8.125 12.334 8.125 12.4998V16.2498C8.125 16.4156 8.05915 16.5745 7.94194 16.6917C7.82473 16.809 7.66576 16.8748 7.5 16.8748H3.75C3.58424 16.8748 3.42527 16.809 3.30806 16.6917C3.19085 16.5745 3.125 16.4156 3.125 16.2498V9.02324C3.1264 8.93674 3.14509 8.8514 3.17998 8.77224C3.21486 8.69308 3.26523 8.6217 3.32812 8.5623L9.57812 2.88261C9.69334 2.77721 9.84384 2.71875 10 2.71875C10.1562 2.71875 10.3067 2.77721 10.4219 2.88261L16.6719 8.5623C16.7348 8.6217 16.7851 8.69308 16.82 8.77224C16.8549 8.8514 16.8736 8.93674 16.875 9.02324V16.2498C16.875 16.4156 16.8092 16.5745 16.6919 16.6917C16.5747 16.809 16.4158 16.8748 16.25 16.8748H12.5C12.3342 16.8748 12.1753 16.809 12.0581 16.6917C11.9408 16.5745 11.875 16.4156 11.875 16.2498Z"
                stroke="#67A110"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.875 16.2498V12.4998C11.875 12.334 11.8092 12.1751 11.6919 12.0579C11.5747 11.9406 11.4158 11.8748 11.25 11.8748H8.75C8.58424 11.8748 8.42527 11.9406 8.30806 12.0579C8.19085 12.1751 8.125 12.334 8.125 12.4998V16.2498C8.125 16.4156 8.05915 16.5745 7.94194 16.6917C7.82473 16.809 7.66576 16.8748 7.5 16.8748H3.75C3.58424 16.8748 3.42527 16.809 3.30806 16.6917C3.19085 16.5745 3.125 16.4156 3.125 16.2498V9.02324C3.1264 8.93674 3.14509 8.8514 3.17998 8.77224C3.21486 8.69308 3.26523 8.6217 3.32812 8.5623L9.57812 2.88261C9.69334 2.77721 9.84384 2.71875 10 2.71875C10.1562 2.71875 10.3067 2.77721 10.4219 2.88261L16.6719 8.5623C16.7348 8.6217 16.7851 8.69308 16.82 8.77224C16.8549 8.8514 16.8736 8.93674 16.875 9.02324V16.2498C16.875 16.4156 16.8092 16.5745 16.6919 16.6917C16.5747 16.809 16.4158 16.8748 16.25 16.8748H12.5C12.3342 16.8748 12.1753 16.809 12.0581 16.6917C11.9408 16.5745 11.875 16.4156 11.875 16.2498Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function FlyersIcon({ isActive }) {
    return isActive === "Flyers" ? (
        <svg
            color="#a6df50"
            width={19}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke="#a6df50"
                strokeOpacity={0.7}
                strokeLinecap="round"
                d="M.5 13.913h17.087"
            />
            <path stroke="#a6df50" strokeLinecap="round" d="M.5 16h17.087" />
            <g clipPath="url(#a)" stroke="#a6df50">
                <path d="M6 11H1l4-7.5 3 4" strokeOpacity={0.7} />
                <path d="M17.208 11.13H5.748l5.73-9.65 5.73 9.65Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path
                        fill="#fff"
                        transform="translate(0 .5)"
                        d="M0 0h18v11H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    ) : (
        <svg
            color="#a6df50"
            width={19}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke="#000"
                strokeOpacity={0.7}
                strokeLinecap="round"
                d="M.5 13.913h17.087"
            />
            <path stroke="#000" strokeLinecap="round" d="M.5 16h17.087" />
            <g clipPath="url(#a)" stroke="#000">
                <path d="M6 11H1l4-7.5 3 4" strokeOpacity={0.7} />
                <path d="M17.208 11.13H5.748l5.73-9.65 5.73 9.65Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path
                        fill="#fff"
                        transform="translate(0 .5)"
                        d="M0 0h18v11H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
function MyVideosIcon({ isActive }) {
    return isActive === "Property Videos" ||
        isActive === "Property Videos Form" ? (
        <svg
            width={17}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={8.5} cy={8.5} r={8} stroke="#67A110" />
            <path
                d="M12 8.5 7 5v7l5-3.5Z"
                stroke="#67A110"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={17}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={8.5} cy={8.5} r={8} stroke="#000" />
            <path
                d="M12 8.5 7 5v7l5-3.5Z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function UserIcon() {
    return (
        <IconContext.Provider
            value={{
                style: {
                    fontSize: "38px",
                    color: "rgb(70,70,70)",
                },
            }}
        >
            <div>
                <FaUserCircle />
            </div>
        </IconContext.Provider>
    );
}

function TopbarSignout() {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.313 8.063 20.25 12l-3.938 3.938M9.75 12h10.5M9.75 20.25H4.5a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h5.25"
                stroke="#707070"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function SidebarProfileIcon({ isActive }) {
    return isActive === "My Profile" ? (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.098 1.197a9.9 9.9 0 1 0 0 19.802 9.9 9.9 0 0 0 0-19.802Zm0 2.96a3.275 3.275 0 1 1 0 6.55 3.275 3.275 0 0 1 0-6.55Zm-.002 14.255a7.267 7.267 0 0 1-4.732-1.745 1.395 1.395 0 0 1-.49-1.061 3.303 3.303 0 0 1 3.32-3.302h3.81a3.299 3.299 0 0 1 3.314 3.302 1.395 1.395 0 0 1-.49 1.06 7.264 7.264 0 0 1-4.732 1.746Z"
                stroke="#67A110"
                strokeWidth={1.057}
            />
        </svg>
    ) : (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1.1a9.901 9.901 0 1 0 .002 19.803A9.901 9.901 0 0 0 11 1.1Zm0 2.96a3.275 3.275 0 1 1 .002 6.55A3.275 3.275 0 0 1 11 4.06ZM11 18.316a7.267 7.267 0 0 1-4.733-1.745 1.396 1.396 0 0 1-.49-1.06 3.303 3.303 0 0 1 3.32-3.303h3.81a3.299 3.299 0 0 1 3.315 3.302 1.392 1.392 0 0 1-.49 1.06A7.265 7.265 0 0 1 11 18.315Z"
                stroke="#000"
                strokeWidth={1.2}
            />
        </svg>
    );
}

function SidebarCouponIcon({ isActive }) {
    return isActive === "Coupons" ? (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 7.5H3.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.5 12v6.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12M12 7.5v12"
                stroke="#67A110"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.247 6.44C15.178 7.5 12 7.5 12 7.5s0-3.178 1.06-4.247a2.254 2.254 0 0 1 3.187 3.187v0ZM7.754 6.44C8.823 7.5 12 7.5 12 7.5s0-3.178-1.06-4.247A2.254 2.254 0 0 0 7.754 6.44v0Z"
                stroke="#67A110"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 7.5H3.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75ZM19.5 12v6.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12M12 7.5v12"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.247 6.44C15.178 7.5 12 7.5 12 7.5s0-3.178 1.06-4.247a2.254 2.254 0 0 1 3.187 3.187v0ZM7.754 6.44C8.823 7.5 12 7.5 12 7.5s0-3.178-1.06-4.247A2.254 2.254 0 0 0 7.754 6.44v0Z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function SidebarReferIcon({ isActive }) {
    return isActive === "Referrals" ? (
        <svg
            width={21}
            height={23}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.658 12.01a5.513 5.513 0 0 1-5.506-5.506A5.51 5.51 0 0 1 8.658 1a5.51 5.51 0 0 1 5.504 5.504 5.51 5.51 0 0 1-5.504 5.506Zm0-9.784a4.282 4.282 0 0 0-4.277 4.278 4.282 4.282 0 0 0 4.277 4.277 4.282 4.282 0 0 0 4.278-4.277 4.283 4.283 0 0 0-4.278-4.278Z"
                fill="#67A110"
                stroke="#F5F5F5"
                strokeWidth={0.3}
            />
            <path
                d="M3.463 21.184c-.409 0-1.578-.066-2.298-.75-.82-.778-.783-2.06-.753-2.435.308-3.744 4.078-6.907 8.233-6.907 1.705 0 3.348.52 4.748 1.5.188.132.372.272.55.419a.62.62 0 0 1 .087.856.591.591 0 0 1-.84.089 7.064 7.064 0 0 0-4.543-1.648c-3.56 0-6.784 2.652-7.043 5.79-.04.502.059 1.143.376 1.442.407.388 1.31.436 1.592.421h9.906c.33 0 .596.272.596.609a.608.608 0 0 1-.598.612H3.598c-.018.003-.066.003-.135.003Z"
                fill="#67A110"
                stroke="#F5F5F5"
                strokeWidth={0.3}
            />
            <path
                d="M16.884 21.469a.52.52 0 0 1-1.04 0v-7.065a.52.52 0 0 1 1.04 0v7.065Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.3}
            />
            <path
                d="M19.901 17.417a.52.52 0 0 1 0 1.04h-7.064a.52.52 0 0 1 0-1.04H19.9Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.3}
            />
            <path
                d="M4.576 4.132c1.567-2.088 5.43-3.654 8.352.522 1.044 2.61-.522 6.264-4.175 6.264-1.054.105-4.29-.45-4.227-2.696-.168.295-.656-1.973.05-4.09Z"
                fill="#67A110"
            />
        </svg>
    ) : (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.577 11.807a5.912 5.912 0 0 1-5.905-5.904A5.91 5.91 0 0 1 9.577 0a5.91 5.91 0 0 1 5.902 5.903 5.91 5.91 0 0 1-5.902 5.904Zm0-10.492a4.592 4.592 0 0 0-4.588 4.588 4.592 4.592 0 0 0 4.588 4.587 4.592 4.592 0 0 0 4.587-4.587 4.593 4.593 0 0 0-4.587-4.588Z"
                fill="#000"
            />
            <path
                d="M3.775 21.757c-.45 0-1.739-.071-2.532-.811-.903-.84-.863-2.225-.83-2.63.34-4.046 4.494-7.463 9.073-7.463a9.208 9.208 0 0 1 5.838 2.073.66.66 0 0 1 .096.925.66.66 0 0 1-.925.095 7.891 7.891 0 0 0-5.006-1.781c-3.924 0-7.477 2.867-7.762 6.257-.045.542.064 1.235.414 1.558.448.42 1.445.47 1.754.455h10.916c.363 0 .658.294.658.658a.663.663 0 0 1-.66.662H3.924c-.02.002-.073.002-.149.002ZM17.625 21.167a.515.515 0 0 1-1.03 0v-6.992a.515.515 0 0 1 1.03 0v6.992Z"
                fill="#000"
            />
            <path
                d="M17.111 21.844a.679.679 0 0 1-.677-.678v-6.992a.679.679 0 0 1 1.355 0v6.992a.677.677 0 0 1-.678.678Zm0-8.02a.35.35 0 0 0-.35.35v6.992a.35.35 0 0 0 .7 0v-6.992a.35.35 0 0 0-.35-.35Z"
                fill="#000"
            />
            <path
                d="M20.61 17.157a.515.515 0 0 1 0 1.03h-6.992a.515.515 0 0 1 0-1.03h6.993Z"
                fill="#000"
            />
            <path
                d="M20.61 18.35h-6.993a.679.679 0 0 1 0-1.355h6.993a.679.679 0 0 1 0 1.355Zm-6.993-1.03a.35.35 0 0 0 0 .7h6.993a.35.35 0 0 0 0-.7h-6.993Z"
                fill="#000"
            />
        </svg>
    );
}

function SidebarSupportIcon({ isActive }) {
    return isActive === "Support" ? (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.14 12h-3a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V12Zm0 0a8.998 8.998 0 0 0-9.074-9A9 9 0 0 0 3 12v5.25a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5V13.5A1.5 1.5 0 0 0 6 12H3"
                stroke="#67A110"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.14 17.25v2.25a3 3 0 0 1-3 3h-5.39"
                stroke="#67A110"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.14 12h-3a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V12Zm0 0a8.998 8.998 0 0 0-9.074-9A9 9 0 0 0 3 12v5.25a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5V13.5A1.5 1.5 0 0 0 6 12H3"
                stroke="#000"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.14 17.25v2.25a3 3 0 0 1-3 3h-5.39"
                stroke="#000"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function SidebarSignout() {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.313 8.063 20.25 12l-3.938 3.938M9.75 12h10.5M9.75 20.25H4.5a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h5.25"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function DropdownArrowBigDown() {
    return (
        <svg
            className="ud-aid-hist-dropdown-arr-icon-2"
            width={12}
            height={7}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1 6 6 1 1"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function DropdownArrowBigUp() {
    return (
        <svg
            className="ud-aid-hist-dropdown-arr-icon-2"
            width={13}
            height={7}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m1.5 6 5-5 5 5"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function DropdownArrowSmallDown() {
    return (
        <svg
            width={8}
            height={4}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ud-aid-hist-dropdown-arr-icon-2"
        >
            <path
                d="m1 .5 3 3 3-3"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function DropdownArrowSmallUp() {
    return (
        <svg
            width={8}
            height={4}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ud-aid-hist-dropdown-arr-icon-2"
        >
            <path
                d="m1 3.5 3-3 3 3"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function NotFoundIcon() {
    return (
        <svg
            width={254}
            height={247}
            viewBox="0 0 254 247"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.692826 58.1205C1.22192 62.0705 2.74287 65.8221 5.11379 69.0254C7.48472 72.2287 10.6284 74.7792 14.2515 76.4392C17.8746 78.0991 21.8591 78.8143 25.8334 78.518C29.8076 78.2218 33.642 76.9237 36.979 74.745L46.0706 77.8357C46.3449 77.9261 46.6393 77.9361 46.919 77.8644C47.1988 77.7928 47.4521 77.6425 47.6492 77.4314C47.8462 77.2203 47.9786 76.9572 48.0309 76.6732C48.0831 76.3891 48.0529 76.0961 47.9438 75.8287L44.2978 67.1318C46.2369 63.9014 47.374 60.2535 47.6139 56.4934C47.8538 52.7333 47.1895 48.9705 45.6766 45.5198C44.1637 42.0691 41.8463 39.0311 38.9182 36.6599C35.9902 34.2888 32.5368 32.6535 28.847 31.891C25.1572 31.1284 21.3385 31.2609 17.7104 32.2771C14.0823 33.2934 10.7505 35.164 7.99371 37.7323C5.23695 40.3006 3.13552 43.4919 1.86531 47.0391C0.59509 50.5862 0.193045 54.3861 0.692826 58.1205Z"
                fill="url(#paint0_linear_3637_24416)"
            />
            <path
                d="M23.4543 67.0609C26.0158 67.0609 27.8404 65.3064 27.8404 62.8502C27.8404 60.394 26.0158 58.6396 23.4543 58.6396C20.928 58.6396 19.0683 60.394 19.0683 62.8502C19.0683 65.3064 20.928 67.0609 23.4543 67.0609ZM26.9632 57.9378C26.9632 55.6219 28.2966 54.7798 30.1212 53.9377C32.5423 52.8149 34.3318 50.5341 34.3318 47.727C34.3318 43.3058 29.9808 40.218 24.0859 40.218C17.77 40.218 13.3137 43.762 12.9277 48.7095L20.9981 50.1832C21.2087 48.2533 22.2262 46.8849 23.6649 46.8849C24.7526 46.8849 25.5597 47.6217 25.5597 48.6393C25.5597 49.8323 24.3666 50.5692 23.4192 51.1306C20.8929 52.7798 19.9455 54.6044 19.9455 57.9378H26.9632Z"
                fill="white"
            />
            <path
                d="M73.7569 234.426C73.5085 233.451 74.408 232.573 75.3762 232.845L81.9111 234.682C82.8792 234.954 83.1898 236.172 82.4701 236.874L77.6123 241.615C76.8926 242.318 75.6824 241.978 75.434 241.003L73.7569 234.426Z"
                fill="#65C8DE"
            />
            <path
                d="M252.022 63.8889C252.022 65.873 250.414 67.4814 248.43 67.4814C246.446 67.4814 244.837 65.873 244.837 63.8889C244.837 61.9048 246.446 60.2964 248.43 60.2964C250.414 60.2964 252.022 61.9048 252.022 63.8889Z"
                stroke="url(#paint1_linear_3637_24416)"
                strokeWidth={1.95953}
            />
            <path
                d="M96.2371 6.5639C96.7981 4.64574 99.5154 4.64574 100.076 6.5639L101.397 11.0783C101.588 11.733 102.1 12.245 102.755 12.4365L107.269 13.7567C109.187 14.3176 109.187 17.0349 107.269 17.5959L102.755 18.9161C102.1 19.1076 101.588 19.6196 101.397 20.2743L100.076 24.7886C99.5154 26.7068 96.7981 26.7068 96.2371 24.7886L94.9169 20.2743C94.7255 19.6196 94.2135 19.1076 93.5587 18.9161L89.0444 17.5959C87.1262 17.0349 87.1262 14.3176 89.0444 13.7567L93.5587 12.4365C94.2135 12.245 94.7255 11.733 94.9169 11.0783L96.2371 6.5639Z"
                fill="#EDEFF0"
            />
            <path
                d="M130.894 237.266C186.056 237.266 230.773 192.744 230.773 137.824C230.773 82.9033 186.056 38.3813 130.894 38.3813C75.7328 38.3813 31.0156 82.9033 31.0156 137.824C31.0156 192.744 75.7328 237.266 130.894 237.266Z"
                fill="url(#paint2_linear_3637_24416)"
            />
            <path
                d="M196.752 92.8865C196.752 94.7565 196.471 96.6159 195.92 98.4027C195.026 101.268 193.447 103.871 191.319 105.987C190.694 106.62 190.023 107.204 189.31 107.735C188.841 108.1 188.349 108.434 187.836 108.734C187.324 109.047 186.796 109.333 186.254 109.59C185.446 109.989 184.607 110.323 183.746 110.588C181.959 111.14 180.1 111.42 178.23 111.42H174.782V200.762H78.4863V90.9487C78.502 86.5551 80.2543 82.3459 83.3611 79.2391C86.4678 76.1324 90.677 74.3801 95.0706 74.3644H178.182C180.497 74.3555 182.793 74.7872 184.947 75.6364C185.544 75.8681 186.128 76.134 186.694 76.433C186.98 76.5756 187.253 76.7302 187.527 76.8966C187.751 77.02 187.97 77.1549 188.18 77.3008C189.304 78.0112 190.344 78.8446 191.283 79.7855C192.544 81.0486 193.617 82.4859 194.469 84.0534C195.046 85.1098 195.516 86.2209 195.872 87.3703L196.122 88.2619C196.275 88.8576 196.398 89.4607 196.49 90.0689C196.65 90.9999 196.738 91.942 196.752 92.8865Z"
                fill="url(#paint3_linear_3637_24416)"
            />
            <rect
                x={82.4805}
                y={139.568}
                width={84.6133}
                height={7.85072}
                rx={3.92536}
                fill="#D9D9D9"
                fillOpacity={0.25}
            />
            <rect
                x={82.4805}
                y={158.759}
                width={84.6133}
                height={7.85072}
                rx={3.92536}
                fill="#D9D9D9"
                fillOpacity={0.25}
            />
            <rect
                x={82.4805}
                y={177.95}
                width={84.6133}
                height={7.85072}
                rx={3.92536}
                fill="#D9D9D9"
                fillOpacity={0.25}
            />
            <rect
                x={82.4805}
                y={120.378}
                width={84.6133}
                height={7.85072}
                rx={3.92536}
                fill="#D9D9D9"
                fillOpacity={0.25}
            />
            <rect
                x={82.4805}
                y={101.187}
                width={45.3597}
                height={7.85072}
                rx={3.92536}
                fill="#D9D9D9"
                fillOpacity={0.25}
            />
            <path
                d="M118.797 134.884L137.436 153.523"
                stroke="#FF4269"
                strokeWidth={6.97128}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M137.432 134.884L118.793 153.523"
                stroke="#FF4269"
                strokeWidth={6.97128}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M196.751 92.8865C196.751 94.7565 196.47 96.6159 195.919 98.4027C195.554 99.5491 195.085 100.659 194.516 101.72C193.655 103.285 192.579 104.722 191.318 105.988C190.693 106.62 190.022 107.204 189.309 107.735C188.833 108.092 188.346 108.413 187.835 108.734C187.323 109.047 186.796 109.333 186.254 109.59C185.443 109.984 184.605 110.317 183.745 110.588C181.958 111.14 180.099 111.42 178.229 111.42H174.781V90.9487C174.789 87.675 175.762 84.4762 177.578 81.7526C179.395 79.029 181.974 76.9015 184.993 75.6365C185.588 75.8742 186.182 76.1358 186.741 76.433C187.026 76.5757 187.3 76.7302 187.573 76.8966C187.798 77.02 188.016 77.1549 188.227 77.3008C189.35 78.0113 190.391 78.8446 191.33 79.7855C192.59 81.0487 193.663 82.4859 194.516 84.0534C195.087 85.1122 195.557 86.2228 195.919 87.3703L196.168 88.2619C196.323 88.8573 196.446 89.4605 196.537 90.069C196.681 91.0012 196.752 91.9432 196.751 92.8865Z"
                fill="url(#paint4_linear_3637_24416)"
            />
            <path
                d="M166.029 207.608H87.0346C82.1107 207.608 78.1191 204.484 78.1191 200.629H174.945C174.945 204.484 170.953 207.608 166.029 207.608Z"
                fill="#A6A6A6"
                fillOpacity={0.29}
            />
            <g filter="url(#filter0_d_3637_24416)">
                <path
                    d="M49.9004 111.596L40.0445 135.836C39.9099 136.168 39.711 136.47 39.4593 136.726C39.2076 136.981 38.9079 137.184 38.5775 137.323C38.2471 137.462 37.8925 137.535 37.534 137.537C37.1755 137.539 36.8201 137.47 36.4883 137.334L14.4015 128.361C13.7299 128.088 13.1942 127.559 12.9121 126.891C12.6299 126.223 12.6243 125.471 12.8965 124.799L24.2891 96.7805C24.5624 96.1105 25.0904 95.5764 25.7572 95.2954C26.4239 95.0144 27.175 95.0095 27.8454 95.2818L46.1981 102.744L49.9004 111.596Z"
                    fill="url(#paint5_linear_3637_24416)"
                />
            </g>
            <g filter="url(#filter1_d_3637_24416)">
                <path
                    d="M202.859 177.178L211.641 199.091C211.761 199.392 211.938 199.665 212.162 199.896C212.386 200.127 212.653 200.31 212.948 200.436C213.242 200.562 213.558 200.628 213.877 200.63C214.197 200.631 214.513 200.569 214.809 200.446L234.488 192.334C235.086 192.087 235.563 191.609 235.815 191.006C236.066 190.402 236.071 189.721 235.829 189.114L225.678 163.785C225.435 163.179 224.964 162.696 224.37 162.442C223.776 162.188 223.107 162.184 222.51 162.43L206.158 169.175L202.859 177.178Z"
                    fill="url(#paint6_linear_3637_24416)"
                />
            </g>
            <path
                d="M49.9004 111.596L43.6325 109.049L46.1917 102.743L49.9004 111.596Z"
                fill="url(#paint7_linear_3637_24416)"
            />
            <path
                d="M202.859 177.077L208.093 174.819L205.956 169.227L202.859 177.077Z"
                fill="url(#paint8_linear_3637_24416)"
            />
            <path
                d="M163.783 183.878C164.324 183.39 164.648 182.707 164.686 181.979C164.723 181.252 164.471 180.539 163.983 179.998L149.165 163.586C148.923 163.317 148.631 163.099 148.304 162.943C147.977 162.787 147.623 162.697 147.262 162.678C146.901 162.659 146.539 162.711 146.198 162.832C145.857 162.953 145.543 163.139 145.274 163.381C145.005 163.623 144.786 163.916 144.63 164.243C144.475 164.569 144.385 164.923 144.366 165.284C144.347 165.646 144.399 166.007 144.52 166.348C144.64 166.69 144.827 167.004 145.069 167.273L159.887 183.684C160.129 183.954 160.423 184.173 160.75 184.329C161.077 184.485 161.432 184.574 161.794 184.592C162.157 184.61 162.519 184.556 162.86 184.434C163.201 184.311 163.515 184.122 163.783 183.878Z"
                fill="white"
                stroke="#263238"
                strokeWidth={0.654227}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M186.349 208.896C186.826 208.467 187.213 207.948 187.489 207.369C187.765 206.79 187.924 206.162 187.957 205.521C187.991 204.881 187.897 204.24 187.683 203.635C187.468 203.031 187.137 202.474 186.707 201.998L165.553 178.564C164.682 177.603 163.466 177.027 162.17 176.964C160.875 176.9 159.608 177.353 158.647 178.224C157.686 179.095 157.11 180.312 157.047 181.607C156.983 182.902 157.436 184.17 158.307 185.13L179.472 208.529C180.337 209.487 181.546 210.063 182.835 210.131C184.123 210.2 185.387 209.756 186.349 208.896Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth={0.654227}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M108.131 122.687C112.5 118.743 117.94 116.183 123.764 115.332C129.588 114.48 135.533 115.374 140.849 117.901C146.165 120.428 150.612 124.475 153.627 129.529C156.643 134.584 158.092 140.419 157.792 146.297C157.491 152.175 155.454 157.832 151.939 162.553C148.423 167.273 143.587 170.845 138.041 172.817C132.495 174.789 126.489 175.072 120.783 173.63C115.076 172.189 109.925 169.087 105.981 164.718C100.694 158.859 97.9503 151.14 98.3534 143.258C98.7564 135.376 102.273 127.977 108.131 122.687ZM144.563 163.042C148.175 159.781 150.738 155.521 151.929 150.803C153.12 146.084 152.886 141.119 151.255 136.534C149.624 131.948 146.67 127.95 142.766 125.044C138.863 122.137 134.186 120.454 129.325 120.206C124.465 119.958 119.641 121.157 115.462 123.65C111.283 126.144 107.937 129.821 105.848 134.217C103.759 138.612 103.02 143.528 103.725 148.343C104.429 153.158 106.546 157.656 109.807 161.269C114.181 166.112 120.3 169.019 126.818 169.352C133.335 169.684 139.718 167.415 144.563 163.042Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth={0.654227}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter
                    id="filter0_d_3637_24416"
                    x={10.5615}
                    y={95.0811}
                    width={51.4416}
                    height={57.4065}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={4.98348} dy={7.83118} />
                    <feGaussianBlur stdDeviation={3.55963} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3637_24416"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3637_24416"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_3637_24416"
                    x={200.724}
                    y={162.248}
                    width={47.3869}
                    height={53.3318}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={4.98348} dy={7.83118} />
                    <feGaussianBlur stdDeviation={3.55963} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3637_24416"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3637_24416"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_3637_24416"
                    x1={0.711824}
                    y1={34.5772}
                    x2={47.718}
                    y2={79.1291}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF698D" />
                    <stop offset={1} stopColor="#FF3868" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3637_24416"
                    x1={242.81}
                    y1={61.0312}
                    x2={257.098}
                    y2={73.4144}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#74D1CE" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_3637_24416"
                    x1={130.124}
                    y1={6.00044}
                    x2={132.153}
                    y2={355.227}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E7E7E7" />
                    <stop offset={0.0001} stopColor="#F7FBFC" />
                    <stop offset={1} stopColor="#E6E6E6" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_3637_24416"
                    x1={137.619}
                    y1={74.3643}
                    x2={137.619}
                    y2={200.762}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset={1} stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_3637_24416"
                    x1={188.537}
                    y1={106.613}
                    x2={162.548}
                    y2={86.6214}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F4F4F4" />
                    <stop offset={1} stopColor="#C9C9C9" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_3637_24416"
                    x1={16.7339}
                    y1={113.976}
                    x2={41.7836}
                    y2={111.475}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEFFFF" />
                    <stop offset={1} stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_3637_24416"
                    x1={232.409}
                    y1={179.33}
                    x2={210.085}
                    y2={177.133}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset={1} stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_3637_24416"
                    x1={46.7665}
                    y1={102.743}
                    x2={46.7665}
                    y2={111.596}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#15B81B" stopOpacity={0.53} />
                    <stop offset={1} stopColor="#F2FFF2" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_3637_24416"
                    x1={205.476}
                    y1={169.227}
                    x2={205.476}
                    y2={177.077}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#15B81B" stopOpacity={0.53} />
                    <stop offset={1} stopColor="#F2FFF2" />
                </linearGradient>
            </defs>
        </svg>
    );
}

const icon = {
    BarsIcon,
    HomeIcon,
    TopbarSupportIcon,
    TopbarReferIcon,
    OrderIcon,
    ServiceIcon,
    TeamIcon,
    TopbarProfileIcon,
    TopbarCouponIcon,
    StyleGuideIcon,
    UserIcon,
    TopbarSignout,
    CreateVideosIcon,
    MyVideosIcon,
    AimhBuildingIcon,
    AimhEmailIcon,
    AimhSocialMediaIcon,
    AimhAgentsBioIcon,
    AimhHistoryIcon,
    AimhHomeIcon,
    AimhBullHornIcon,
    RewriteContentIcon,
    FlyersIcon,
    SidebarSignout,
    SidebarSupportIcon,
    SidebarCouponIcon,
    SidebarReferIcon,
    SidebarProfileIcon,
    DropdownArrowSmallUp,
    DropdownArrowSmallDown,
    DropdownArrowBigUp,
    DropdownArrowBigDown,
    NotFoundIcon,
};

export default icon;
